// Generated by Avo VERSION 233.46.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "rHXH41ZY5fXuixTtBmEL";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "P2cbUcdaNxmEY84KkdMt",
          "br": "XAevbhjo85paEkYAzKVZJ",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "7JBjRhWGgpbREMm61E1Y",
          "se": (new Date()).toISOString(),
          "so": "votbEGr9_ZZB8Y_DPd8mm",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "P2cbUcdaNxmEY84KkdMt",
          "br": "XAevbhjo85paEkYAzKVZJ",
          "en": env,
          "ty": type,
          "sc": "7JBjRhWGgpbREMm61E1Y",
          "se": (new Date()).toISOString(),
          "so": "votbEGr9_ZZB8Y_DPd8mm",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "7JBjRhWGgpbREMm61E1Y",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface RecIdList {
  recId: string
}

export interface LoopIdList {
  loopId: string
}

export interface ItemIdArray {
  itemId: string
}

export interface ParametersApplied {
  instructionType: InstructionTypeValueType
  instructionValue: InstructionValueValueType
}

export const SegmentSourceType = {
  'API': 'api',
  'BROWSER': 'browser',
  'SERVER': 'server',
} as const;
export type SegmentSourceTypeType = typeof SegmentSourceType;
export type SegmentSourceTypeValueType = SegmentSourceTypeType[keyof SegmentSourceTypeType];

export const PermissionsGranted = {
  'APPROVE_PLANS': 'Approve Plans',
  'APPROVE_WORKLOGS': 'Approve Worklogs',
  'MANAGE_PLANS': 'Manage Plans',
  'MANAGE_TEAM': 'Manage Team',
  'MANAGE_WORKLOGS': 'Manage Worklogs',
  'VIEW_PLANS': 'View Plans',
  'VIEW_WORKLOGS': 'View Worklogs',
} as const;
export type PermissionsGrantedType = typeof PermissionsGranted;
export type PermissionsGrantedValueType = PermissionsGrantedType[keyof PermissionsGrantedType];

export const ItemFieldNames = {
  'ESTIMATION': 'estimation',
  'PRIORITY': 'priority',
  'TARGET_FINISH_DATE': 'target_finish_date',
  'TARGET_START_DATE': 'target_start_date',
  'TEAM': 'team',
} as const;
export type ItemFieldNamesType = typeof ItemFieldNames;
export type ItemFieldNamesValueType = ItemFieldNamesType[keyof ItemFieldNamesType];

export const ApprovalStatus = {
  'APPROVED': 'Approved',
  'NOT_SET': 'Not set',
  'PENDING': 'Pending',
  'REJECTED': 'Rejected',
} as const;
export type ApprovalStatusType = typeof ApprovalStatus;
export type ApprovalStatusValueType = ApprovalStatusType[keyof ApprovalStatusType];

export const RepeatRule = {
  'BI_WEEKLY': 'Bi-weekly',
  'MONTHLY': 'Monthly',
  'NEVER': 'Never',
  'WEEKLY': 'Weekly',
} as const;
export type RepeatRuleType = typeof RepeatRule;
export type RepeatRuleValueType = RepeatRuleType[keyof RepeatRuleType];

export const IntelligenceReadingView = {
  'AGENTIC': 'agentic',
  'CLASSIC': 'classic',
} as const;
export type IntelligenceReadingViewType = typeof IntelligenceReadingView;
export type IntelligenceReadingViewValueType = IntelligenceReadingViewType[keyof IntelligenceReadingViewType];

export const PlanType = {
  'COMPONENT': 'Component',
  'ISSUE': 'Issue',
  'PROJECT': 'Project',
  'SPRINT': 'Sprint',
  'VERSION': 'Version',
} as const;
export type PlanTypeType = typeof PlanType;
export type PlanTypeValueType = PlanTypeType[keyof PlanTypeType];

export const CategoryLens = {
  'ALL': 'all',
  'EFFICIENCY': 'efficiency',
  'FOCUS': 'focus',
  'GROWTH': 'growth',
  'RISK': 'risk',
  'DATA_READINESS': 'dataReadiness',
  'ONTRACK': 'ontrack',
  'OPPORTUNITY': 'opportunity',
} as const;
export type CategoryLensType = typeof CategoryLens;
export type CategoryLensValueType = CategoryLensType[keyof CategoryLensType];

export const IntelligenceTab = {
  'ASSIGNED': 'assigned',
  'COMPLETED': 'completed',
  'NEW': 'new',
} as const;
export type IntelligenceTabType = typeof IntelligenceTab;
export type IntelligenceTabValueType = IntelligenceTabType[keyof IntelligenceTabType];

export const Rating = {
  'NEGATIVE': 'negative',
  'POSITIVE': 'positive',
} as const;
export type RatingType = typeof Rating;
export type RatingValueType = RatingType[keyof RatingType];

export const VisualizationPublishAction = {
  'DELETE': 'delete',
  'UPDATE': 'update',
} as const;
export type VisualizationPublishActionType = typeof VisualizationPublishAction;
export type VisualizationPublishActionValueType = VisualizationPublishActionType[keyof VisualizationPublishActionType];

export const VisualizationArtifactType = {
  'SWIMLANE': 'swimlane',
  'TIMELINE': 'timeline',
} as const;
export type VisualizationArtifactTypeType = typeof VisualizationArtifactType;
export type VisualizationArtifactTypeValueType = VisualizationArtifactTypeType[keyof VisualizationArtifactTypeType];

export const TimeSelection = {
  'PER_DAY': 'Per Day',
  'TOTAL': 'Total',
} as const;
export type TimeSelectionType = typeof TimeSelection;
export type TimeSelectionValueType = TimeSelectionType[keyof TimeSelectionType];

export const OriginView = {
  'ABOUT': 'About',
  'ADD_MULTIPLE_TASKS': 'Add Multiple Tasks',
  'ADMINS': 'Admins',
  'ALLOCATION': 'Allocation',
  'APPROVALS': 'Approvals',
  'ASSIGNMENTS': 'Assignments',
  'ATTACHED_FILES': 'Attached Files',
  'AVAILABILITY': 'Availability',
  'BOARD': 'Board',
  'BULK_ACTION_COMPLETE': 'Bulk Action Complete',
  'BULK_ACTION_IN_PROGRESS': 'Bulk Action In Progress',
  'CALENDAR': 'Calendar',
  'CAPACITY': 'Capacity',
  'CHANGES': 'Changes',
  'CHANGES_BY_ME': 'Changes by me',
  'CONFIGURATION': 'Configuration',
  'CONFIGURATION_GENERAL': 'Configuration - General',
  'CONFIGURATION_SHARING': 'Configuration - Sharing',
  'CONNECTIONS': 'Connections',
  'COST_REPORT': 'CostReport',
  'DASHBOARD_REPORTS': 'Dashboard & Reports',
  'DASHBOARD_GUESTS': 'Dashboard Guests',
  'DAY': 'Day',
  'DAY_VIEW': 'Day View',
  'DAYS': 'Days',
  'DEFINE_LEVELS': 'Define Levels',
  'DELETED_ITEMS': 'Deleted Items',
  'DEV_NOTES': 'Dev Notes',
  'DISCONNECTED_USERS': 'Disconnected Users',
  'DISCOVER': 'Discover',
  'DISCUSSION': 'Discussion',
  'EMPTY_STATE': 'Empty State',
  'EVERYONE_TIME_OFF': 'Everyone Time Off',
  'EXPENSES': 'Expenses',
  'FEEDBACK_MODE_COMPLETED': 'Feedback Mode Completed',
  'FEEDBACK_MODE_FINAL_MODAL': 'Feedback Mode Final Modal',
  'FEEDBACK_MODE_STARTED': 'Feedback Mode Started',
  'FILE': 'File',
  'GLOBAL': 'Global',
  'GLOBAL_BILLING_RATES': 'Global Billing Rates',
  'GLOBAL_COST_RATES': 'Global Cost Rates',
  'GRID': 'Grid',
  'GROUP_ACCESS': 'Group Access',
  'GROUPS': 'Groups',
  'GUEST_ACCESS': 'Guest Access',
  'GUEST_PROFILE': 'Guest Profile',
  'HUD_VIEW': 'Hud View',
  'IMPORT_TASKS_FROM_EXCEL': 'Import Tasks from Excel',
  'INBOX_VIEW': 'Inbox View',
  'INDIVIDUAL': 'Individual',
  'INTEGRATIONS': 'Integrations',
  'INVITE_GUEST': 'Invite Guest',
  'ISSUE_PICKER_VIEW': 'Issue Picker View',
  'ISSUE_PASSED_TIME_BY_RESOLUTION': 'IssuePassedTimeByResolution',
  'ISSUE_PASSED_TIME_BY_STATUS': 'IssuePassedTimeByStatus',
  'ISSUE_TIME': 'IssueTime',
  'ISSUE_TIME_BALANCE': 'IssueTimeBalance',
  'ISSUE_WORKED_TIME_BY_LABEL': 'IssueWorkedTimeByLabel',
  'ISSUE_WORKED_TIME_BY_STATUS': 'IssueWorkedTimeByStatus',
  'ISSUE_WORKED_TIME_BY_USER': 'IssueWorkedTimeByUser',
  'LAYOUT': 'Layout',
  'LIBRARY': 'Library',
  'LICENSED_USERS': 'Licensed Users',
  'LIST': 'List',
  'MEMBERS': 'Members',
  'MONTH': 'Month',
  'MONTHS': 'Months',
  'MY_WORK': 'My Work',
  'NAMING': 'Naming',
  'NATIVE_DIALOG': 'Native Dialog',
  'NOTES': 'Notes',
  'ORGANIZATION': 'Organization',
  'OVERVIEW': 'Overview',
  'PENDING_INVITES': 'Pending Invites',
  'PERMISSION_OVERVIEW': 'Permission Overview',
  'PERSONAL': 'Personal',
  'PERSONAL_TIME_OFF': 'Personal Time Off',
  'PIE_CHART': 'PieChart',
  'PLAN_APPROVAL_OVERLAY': 'Plan Approval Overlay',
  'PLAN_ITEMS': 'Plan Items',
  'PORTFOLIO': 'Portfolio',
  'PROFILE': 'Profile',
  'PROFILES': 'Profiles',
  'PROJECT': 'Project',
  'PROJECT_ACCESS': 'Project Access',
  'PROPERTIES': 'Properties',
  'QA_NOTES': 'QA Notes',
  'QUARTERS': 'Quarters',
  'REVIEW_ALL_WORKLOGS_COMPLETED': 'Review All Worklogs Completed',
  'REVIEW_ALL_WORKLOGS_STARTED': 'Review All Worklogs Started',
  'ROADMAP_ITEM_CARD': 'Roadmap Item Card',
  'ROADMAP_SWIMLANE': 'Roadmap Swimlane',
  'ROADMAP_TABLE_VIEW': 'Roadmap Table View',
  'ROADMAP_TIMELINE': 'Roadmap Timeline',
  'ROLES_RULES': 'Roles & Rules',
  'ROLES_AND_RULES': 'Roles and Rules',
  'ROLES_AND_RULES_ACCESS': 'Roles and Rules Access',
  'SCHEDULE': 'Schedule',
  'SCHEDULING': 'Scheduling',
  'SCOPE': 'Scope',
  'SEARCH': 'Search',
  'SELECT_MODE': 'Select Mode',
  'SELECT_PROJECT': 'Select Project',
  'SET_UP_CI': 'Set Up CI',
  'SET_UP_TIMESHEETS': 'Set Up Timesheets',
  'SETTINGS': 'Settings',
  'SETTINGS_FILTER': 'Settings & Filter',
  'SETTINGS_FILTERS': 'Settings & Filters',
  'SETTINGS_VIEW': 'Settings View',
  'SINGLE_PROJECT_VIEW': 'Single Project View',
  'SUMMARY': 'Summary',
  'TASK_BOARD': 'Task Board',
  'TEAM': 'Team',
  'TEMPO_VIEW': 'Tempo View',
  'TIME': 'Time',
  'TIME_BALANCE': 'TimeBalance',
  'TIME_ENTRY': 'TimeEntry',
  'TIME_TRACKING': 'TimeTracking',
  'TIMELINE': 'Timeline',
  'TIMESHEET': 'Timesheet',
  'TIMESPENT': 'Timespent',
  'TRACKER_LIST_VIEW': 'Tracker List View',
  'TRACKER_UPDATE_VIEW': 'Tracker Update View',
  'WEEK': 'Week',
  'WEEK_VIEW': 'Week View',
  'WEEKS': 'Weeks',
  'WELCOME_SCREEN': 'Welcome screen',
  'WORKING_TIMES': 'Working Times',
  'WORKLOAD': 'Workload',
  'WORKSPACE_ACCESS': 'Workspace Access',
  'ADMINISTRATIVE_GROUPS': 'Administrative Groups',
  'WORKING_TEAMS': 'Working Teams',
  'ACCESS_TOKENS_HISTORY': 'Access Tokens History',
  'DATA_SOURCES_HISTORY': 'Data Sources History',
  'EXPORT_HISTORY': 'Export History',
  'BY_ALL_WORK_ITEMS': 'By all work Items',
  'BY_MISSING_DATA': 'By missing data',
  'BY_RISK_TYPE': 'By risk type',
  'CUSTOM_FIELDS': 'Custom fields',
  'DELIVERABLES': 'Deliverables',
  'DEPENDENCIES': 'Dependencies',
  'INVESTMENT_BALANCE': 'Investment Balance',
  'ITEM_DETAILS_PANEL': 'Item Details Panel',
  'PROGRESS': 'Progress',
  'SYSTEM_FIELDS': 'System fields',
  'TAKE_ACTION_PANEL': 'Take Action Panel',
  'INSIGHTS': 'Insights',
} as const;
export type OriginViewType = typeof OriginView;
export type OriginViewValueType = OriginViewType[keyof OriginViewType];

export const InstructionDial = {
  'RADAR': 'radar',
  'SCALE': 'scale',
} as const;
export type InstructionDialType = typeof InstructionDial;
export type InstructionDialValueType = InstructionDialType[keyof InstructionDialType];

export const UserRole = {
  'ADMIN': 'admin',
  'ORCHESTRATOR': 'orchestrator',
  'VISUALIZER': 'visualizer',
  'CONTRIBUTOR': 'contributor',
} as const;
export type UserRoleType = typeof UserRole;
export type UserRoleValueType = UserRoleType[keyof UserRoleType];

export const RecActionType = {
  'ASSIGN': 'assign',
  'COMPLETE': 'complete',
  'DISMISS': 'dismiss',
} as const;
export type RecActionTypeType = typeof RecActionType;
export type RecActionTypeValueType = RecActionTypeType[keyof RecActionTypeType];

export const RecRevertType = {
  'UNDO': 'undo',
  'REDO': 'redo',
} as const;
export type RecRevertTypeType = typeof RecRevertType;
export type RecRevertTypeValueType = RecRevertTypeType[keyof RecRevertTypeType];

export const FieldKind = {
  'CUSTOM': 'custom',
  'STANDARD': 'standard',
} as const;
export type FieldKindType = typeof FieldKind;
export type FieldKindValueType = FieldKindType[keyof FieldKindType];

export const OriginPage = {
  '_INSIGHTS_HUB': ' Insights Hub',
  'API': 'API',
  'API_INTEGRATION': 'API Integration',
  'ACADEMY': 'Academy',
  'ACADEMY_TRACK': 'Academy - Track',
  'ACADEMY_HOME': 'Academy Home',
  'ACCEPT_INVITATION': 'Accept Invitation',
  'ACCESS': 'Access',
  'ACCESS_CONTROL': 'Access Control',
  'ACCOUNT_BILLING_RATES': 'Account Billing Rates',
  'ACCOUNT_OVERVIEW': 'Account Overview',
  'ACCOUNT_TIMESHEET': 'Account Timesheet',
  'ACCOUNTS_IMPORT_EXPORT': 'Accounts Import/Export',
  'ACCOUNTS_OVERVIEW': 'Accounts Overview',
  'ACTIVITY_FEED_CONFIGURATION': 'Activity Feed Configuration',
  'ADD_MEMBER': 'Add Member',
  'ADMINISTRATION': 'Administration',
  'ALL_PROJECTS': 'All Projects',
  'ALL_PROJECTS_SEARCH': 'All Projects - Search',
  'ALL_USERS': 'All Users',
  'ALL_USERS_INVITE': 'All Users - Invite',
  'ARCHIVED': 'Archived',
  'ARCHIVED_DASHBOARD': 'Archived - Dashboard',
  'ARCHIVED_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Changes Widget Click-through',
  'ARCHIVED_DASHBOARD_DESIGN': 'Archived - Dashboard - Design',
  'ARCHIVED_DASHBOARD_DESIGN_GUEST_ACCESS_INVITE': 'Archived - Dashboard - Design - Guest Access - Invite',
  'ARCHIVED_DASHBOARD_INTAKE_SETTINGS': 'Archived - Dashboard - Intake - Settings',
  'ARCHIVED_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Intake Widget Click-through',
  'ARCHIVED_DASHBOARD_LIST_GRID_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - List Grid Widget Click-through',
  'ARCHIVED_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Metrics Widget Click-through',
  'ARCHIVED_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Note Widget Click-through',
  'ARCHIVED_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Task Board Widget Click-through',
  'ARCHIVED_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Workload Widget Click-through',
  'ARCHIVED_REPORT': 'Archived - Report',
  'ARCHIVED_REPORT_DESIGN': 'Archived - Report - Design',
  'AUDIT_LOG': 'Audit Log',
  'AVAILABILITY': 'Availability',
  'BILLING_RATES': 'Billing Rates',
  'BILLING_RATES_TABLE': 'Billing Rates Table',
  'BITBUCKET_INTEGRATION': 'Bitbucket Integration',
  'BOARD': 'Board',
  'BOARD_SIDEBAR': 'Board Sidebar',
  'BULK_EDIT': 'Bulk Edit',
  'BULK_TIME_RECORDS_EDITOR': 'Bulk Time Records Editor',
  'CALENDAR_INTEGRATION': 'Calendar Integration',
  'CAPACITY': 'Capacity',
  'CAPACITY_ALLOCATION': 'Capacity - Allocation',
  'CAPACITY_INSIGHTS_OPERATION_DASHBOARD': 'Capacity Insights Operation Dashboard',
  'CATEGORIES_OVERVIEW': 'Categories Overview',
  'CHANGES': 'Changes',
  'COLLECTIONS': 'Collections',
  'COMPANY_REPORT': 'Company Report',
  'CONFLUENCE_MACRO': 'Confluence macro',
  'CONFLUENCE_MACRO_EDIT': 'Confluence macro edit',
  'CONSOLIDATED_REPORT': 'Consolidated Report',
  'COST_RATES': 'Cost Rates',
  'CUSTOM_FIELD_EXPORT_CONFIGURATION': 'Custom Field Export Configuration',
  'CUSTOMER_OVERVIEW': 'Customer Overview',
  'CUSTOMER_REPORT': 'Customer Report',
  'CUSTOMERS_OVERVIEW': 'Customers Overview',
  'DASHBOARD': 'Dashboard',
  'DASHBOARD_CREATE': 'Dashboard - Create',
  'DASHBOARD_GUEST_ACCESS': 'Dashboard - Guest Access',
  'DASHBOARD_GUEST_ACCESS_WIDGET_CLICK_THROUGH_VIEW': 'Dashboard - Guest Access - Widget Click-through View',
  'DASHBOARDS': 'Dashboards',
  'DATA_RETENTION': 'Data Retention',
  'DISCONNECTED_USER_RESTART_ACCOUNT': 'Disconnected User - Restart Account',
  'DISCONNECTED_USER_LOGIN': 'Disconnected User Login',
  'EDIT_PANEL': 'Edit Panel',
  'EMAIL_CONFIRMATION': 'Email Confirmation',
  'EXPIRED_EMAIL_CONFIRMATION': 'Expired Email Confirmation',
  'EXTENSION_BOARDS': 'Extension boards',
  'EXTENSION_GANTT_CONFLUENCE_MACRO': 'Extension gantt Confluence macro',
  'EXTENSION_GANTT_CONFLUENCE_MACRO_EDIT': 'Extension gantt Confluence macro edit',
  'EXTENSION_GANTT_DASHBOARD': 'Extension gantt dashboard',
  'EXTERNAL_PAGE': 'External Page',
  'FAVORITES': 'Favorites',
  'FORGOT_PASSWORD': 'Forgot Password',
  'GADGET': 'Gadget',
  'GET_STARTED': 'Get Started',
  'GET_STARTED_ADMIN': 'Get Started Admin',
  'GITHUB_INTEGRATION': 'GitHub Integration',
  'GITLAB_INTEGRATION': 'GitLab Integration',
  'GLOBAL_CONFIGURATION_BILLING_RATE': 'Global Configuration Billing Rate',
  'GLOBAL_CONFIGURATION_COST_RATE': 'Global Configuration Cost Rate',
  'GLOBAL_RATES_MOVED': 'Global Rates Moved',
  'GLOBAL_SETTINGS': 'Global Settings',
  'GLOBAL_SETTINGS_BILLING_RATES': 'Global Settings Billing Rates',
  'GLOBAL_SETTINGS_COST_RATES': 'Global Settings Cost Rates',
  'GOOGLE_CALENDAR_INTEGRATION': 'Google Calendar Integration',
  'GRID': 'Grid',
  'GROUP': 'Group',
  'GROUP_ROLES_AND_RULES_ACCESS': 'Group - Roles and Rules Access',
  'GUEST_PASSPORTS': 'Guest Passports',
  'GUEST_PROFILE': 'Guest Profile',
  'HISTORY_BULK_ACTIONS': 'History Bulk Actions',
  'HOLIDAY_SCHEME_CONFIGURATION': 'Holiday Scheme Configuration',
  'HOLIDAY_SCHEME_MEMBERS': 'Holiday Scheme Members',
  'HOLIDAY_SCHEMES': 'Holiday Schemes',
  'HOME': 'Home',
  'HOME_ACCOUNT_FIELDS': 'Home Account Fields',
  'HOME_ALL_FIELDS': 'Home All Fields',
  'HOME_ROADMAP_FIELDS': 'Home Roadmap Fields',
  'IDENTITY_SERVICE': 'Identity Service',
  'INSTALLATION_FAILURE_PAGE': 'Installation Failure Page',
  'INSTALLATION_PAGE': 'Installation Page',
  'INSTALLATION_SUCCESS_PAGE': 'Installation Success Page',
  'INTEGRATIONS': 'Integrations',
  'INTERNAL_ISSUES': 'Internal Issues',
  'ISSUE_HISTORY': 'Issue History',
  'JIRA_MOBILE_APP': 'JIRA Mobile App',
  'JIRA_INTEGRATION': 'Jira Integration',
  'JIRA_ISSUE_SEARCH': 'Jira Issue Search',
  'JIRA_ISSUE_VIEW': 'Jira Issue View',
  'JIRA_DASHBOARD_ITEM': 'Jira dashboard item',
  'LEGACY_TEAM_CAPACITY_REPORT': 'Legacy Team Capacity Report',
  'LIBRARY': 'Library',
  'LOGGED_TIME_REPORT': 'Logged Time Report',
  'LOGGING_WORK_CONFIGURATION': 'Logging Work Configuration',
  'LOGIN': 'Login',
  'LOGOUT': 'Logout',
  'MAINTENANCE': 'Maintenance',
  'MANAGE': 'Manage',
  'MANAGE_ACCOUNT': 'Manage Account',
  'MANAGE_ACCOUNT_DOWNGRADE': 'Manage Account - Downgrade',
  'MANAGE_ACCOUNT_UPGRADE': 'Manage Account - Upgrade',
  'MANAGE_STAFF': 'Manage Staff',
  'MESSAGES': 'Messages',
  'MISSING_INFORMATION': 'Missing Information',
  'MY_DISCUSSIONS': 'My Discussions',
  'MY_FAVORITES': 'My Favorites',
  'MY_WORK': 'My Work',
  'MY_WORK_APPROVALS': 'My Work Approvals',
  'MY_WORK_AVAILABILITY': 'My Work Availability',
  'MY_WORK_CHANGES': 'My Work Changes',
  'MY_WORK_SEARCH': 'My Work Search',
  'N_A': 'N/A',
  'OFFICE_365_INTEGRATION': 'Office 365 Integration',
  'ORGANIZATION_HUB_USERS_INTEGRATIONS': 'Organization Hub - Users - Integrations',
  'ORGANIZATION_HUB_USERS_INTEGRATIONS_SLACK_ADMIN': 'Organization Hub - Users - Integrations - Slack - Admin',
  'ORGANIZATION_USER_PROFILE': 'Organization User Profile',
  'OVERRIDE_MODE': 'Override Mode',
  'PACKAGE': 'Package',
  'PACKAGE_CAPACITY': 'Package - Capacity',
  'PACKAGE_DASHBOARD': 'Package - Dashboard',
  'PACKAGE_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Changes Widget Click-through',
  'PACKAGE_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLIC_THROUGH': 'Package - Dashboard - Dashboard Note Widget Clic-through',
  'PACKAGE_DASHBOARD_DESIGN': 'Package - Dashboard - Design',
  'PACKAGE_DASHBOARD_DESIGN_INVITE_GUEST': 'Package - Dashboard - Design - Invite Guest',
  'PACKAGE_DASHBOARD_GRID_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Grid Widget Click-through',
  'PACKAGE_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Intake Widget Click-through',
  'PACKAGE_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Package - Dashboard - Intake Widget Settings',
  'PACKAGE_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Metrics Widget Click-through',
  'PACKAGE_REPORT_DESIGN': 'Package - Report - Design',
  'PENDING': 'Pending',
  'PENDING_CHANGES': 'Pending - Changes',
  'PENDING_DASHBOARD': 'Pending - Dashboard',
  'PENDING_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Changes Widget Click-through',
  'PENDING_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Dashboard Note Widget Click-through',
  'PENDING_DASHBOARD_DESIGN': 'Pending - Dashboard - Design',
  'PENDING_DASHBOARD_DESIGN_GUEST_ACCESS_INVITE': 'Pending - Dashboard - Design - Guest Access - Invite',
  'PENDING_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Intake Widget Click-through',
  'PENDING_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Pending - Dashboard - Intake Widget Settings',
  'PENDING_DASHBOARD_LIST_GRID_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - List Grid Widget Click-through',
  'PENDING_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Metrics Widget Click-through',
  'PENDING_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Task Board Widget Click-through',
  'PENDING_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Workload Widget Click-through',
  'PENDING_GRID': 'Pending - Grid',
  'PENDING_REPORT': 'Pending - Report',
  'PENDING_REPORT_DESIGN': 'Pending - Report - Design',
  'PENDING_REPORT_DESIGN_SETTINGS': 'Pending - Report - Design - Settings',
  'PENDING_SEARCH': 'Pending - Search',
  'PEOPLE': 'People',
  'PEOPLE_ADD_PLACEHOLDER': 'People - Add Placeholder',
  'PEOPLE_ADD_RESOURCE': 'People - Add Resource',
  'PEOPLE_GROUP': 'People - Group',
  'PEOPLE_MEMBER_PROFILE': 'People - Member Profile',
  'PEOPLE_MEMBER_PROFILE_TASK_BOARD': 'People - Member Profile - Task Board',
  'PEOPLE_MEMBER_PROFILE_WORKLOAD': 'People - Member Profile - Workload',
  'PEOPLE_PLACEHOLDER_PROFILE': 'People - Placeholder Profile',
  'PEOPLE_RESOURCE_PROFILE': 'People - Resource Profile',
  'PERIOD_CONFIGURATION': 'Period Configuration',
  'PERIOD_MANAGEMENT': 'Period Management',
  'PERMISSION_OVERVIEW': 'Permission Overview',
  'PERMISSION_ROLES': 'Permission Roles',
  'PLANNED_TIME_REPORT': 'Planned Time Report',
  'PLANNED_VS_ACTUAL_REPORT': 'Planned vs Actual Report',
  'PLANNER_CROSS_SELL': 'Planner Cross Sell',
  'PLANNING_TIME_CONFIGURATION': 'Planning Time Configuration',
  'PORTABLE_ACADEMY': 'Portable Academy',
  'PORTABLE_ACADEMY_LESSON': 'Portable Academy Lesson',
  'PORTABLE_COURSE': 'Portable Course',
  'PORTABLE_DASHBOARD': 'Portable Dashboard',
  'PORTABLE_ITEM': 'Portable Item',
  'PORTABLE_ITEM_LIBRARY': 'Portable Item Library',
  'PORTABLE_LIBRARY': 'Portable Library',
  'PORTABLE_LIBRARY_ITEM_DASHBOARD': 'Portable Library Item Dashboard',
  'PORTABLE_MANAGE_ACCOUNT': 'Portable Manage Account',
  'PORTABLE_REPORT': 'Portable Report',
  'PORTFOLIO': 'Portfolio',
  'PORTFOLIO_CONFIGURATION_GENERAL': 'Portfolio Configuration General',
  'PORTFOLIO_CONFIGURATION_SHARING': 'Portfolio Configuration Sharing',
  'PORTFOLIO_LIST': 'Portfolio List',
  'PORTFOLIO_NOT_FOUND': 'Portfolio Not Found',
  'PORTFOLIO_SUMMARY': 'Portfolio Summary',
  'PORTFOLIO_TIMELINE': 'Portfolio Timeline',
  'PRINT_REPORT': 'Print Report',
  'PRODUCT_AREA': 'Product Area',
  'PROFILE': 'Profile',
  'PROFILES': 'Profiles',
  'PROGRAMS_OVERVIEW': 'Programs Overview',
  'PROJECT': 'Project',
  'PROJECT_ADD_TASKS': 'Project - Add Tasks',
  'PROJECT_DASHBOARD': 'Project - Dashboard',
  'PROJECT_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Changes Widget Click-through',
  'PROJECT_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Dashboard Note Widget Click-through',
  'PROJECT_DASHBOARD_DESIGN': 'Project - Dashboard - Design',
  'PROJECT_DASHBOARD_DESIGN_INVITE_GUEST': 'Project - Dashboard - Design - Invite Guest',
  'PROJECT_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Intake Widget Click-through',
  'PROJECT_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Project - Dashboard - Intake Widget Settings',
  'PROJECT_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Project - Dashboard - List Widget Click-through',
  'PROJECT_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Metrics Widget Click-through',
  'PROJECT_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Task Board Widget Click-through',
  'PROJECT_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Workload Widget Click-through',
  'PROJECT_LIBRARY': 'Project - Library',
  'PROJECT_REPORT': 'Project - Report',
  'PROJECT_REPORT_DESIGN': 'Project - Report - Design',
  'PROJECT_APPROVALS_OVERVIEW': 'Project Approvals Overview',
  'PROJECT_APPROVALS_TIMESHEET': 'Project Approvals Timesheet',
  'PROJECT_ATTRIBUTES': 'Project Attributes',
  'PROJECT_CONFIGURATION': 'Project Configuration',
  'PROJECT_CONFIGURATION_BILLING_RATES': 'Project Configuration Billing Rates',
  'PROJECT_CONFIGURATION_COST_RATES': 'Project Configuration Cost Rates',
  'PROJECT_CONFIGURATION_GENERAL': 'Project Configuration General',
  'PROJECT_CONFIGURATION_MEMBERS_AND_ROLES': 'Project Configuration Members and Roles',
  'PROJECT_CONFIGURATION_PROJECT_ATTRIBUTES': 'Project Configuration Project Attributes',
  'PROJECT_CONFIGURATION_PROJECT_TIME_APPROVAL': 'Project Configuration Project Time Approval',
  'PROJECT_CONFIGURATION_SHARING': 'Project Configuration Sharing',
  'PROJECT_DEFAULTS': 'Project Defaults',
  'PROJECT_EXPENSES': 'Project Expenses',
  'PROJECT_FEATURES': 'Project Features',
  'PROJECT_LIST': 'Project List',
  'PROJECT_OVERVIEW': 'Project Overview',
  'PROJECT_REVENUE': 'Project Revenue',
  'PROJECT_SCOPE': 'Project Scope',
  'PROJECT_TEAM': 'Project Team',
  'PROJECT_TIME_APPROVAL': 'Project Time Approval',
  'PROJECT_TIMESHEET': 'Project Timesheet',
  'PROJECT_WELCOME': 'Project Welcome',
  'PROJECT_BOARD': 'Project board',
  'REPORT': 'Report',
  'REPORT_LIST': 'Report List',
  'REPORT_PAGE': 'Report Page',
  'REPORTS_DASHBOARD': 'Reports Dashboard',
  'REPORTS_OVERVIEW': 'Reports Overview',
  'RESET_PASSWORD': 'Reset Password',
  'RESOURCE_PLANNING': 'Resource Planning',
  'REVIEW_ALL_WORKLOGS': 'Review All Worklogs',
  'REVIEW_TIME': 'Review Time',
  'REVIEW_TIME_FINAL': 'Review Time Final',
  'ROADMAP_TABLE': 'Roadmap Table',
  'SSO_LOGIN': 'SSO Login',
  'SCHEDULED': 'Scheduled',
  'SCHEDULED_CHANGES': 'Scheduled - Changes',
  'SCHEDULED_DASHBOARD': 'Scheduled - Dashboard',
  'SCHEDULED_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Changes Widget Click-through',
  'SCHEDULED_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Dashboard Note Widget Click-through',
  'SCHEDULED_DASHBOARD_DESIGN': 'Scheduled - Dashboard - Design',
  'SCHEDULED_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Intake Widget Click-through',
  'SCHEDULED_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Scheduled - Dashboard - Intake Widget Settings',
  'SCHEDULED_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - List Widget Click-through',
  'SCHEDULED_DASHBOARD_METRIC_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Metric Widget Click-through',
  'SCHEDULED_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Task Board Widget Click-through',
  'SCHEDULED_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Workload Widget Click-through',
  'SCHEDULED_GRID': 'Scheduled - Grid',
  'SCHEDULED_REPORT': 'Scheduled - Report',
  'SCHEDULED_REPORT_DESIGN': 'Scheduled - Report - Design',
  'SCHEDULED_SEARCH': 'Scheduled - Search',
  'SCHEDULED_WORKLOAD': 'Scheduled - Workload',
  'SCHEDULER_CONFIGURATION': 'Scheduler Configuration',
  'SEARCH': 'Search',
  'SET_PASSWORD': 'Set Password',
  'SETTINGS': 'Settings',
  'SINGLE_SIGN_ON': 'Single Sign On',
  'SINGLE_SIGN_ON_MANAGE_SSO': 'Single Sign On - Manage SSO',
  'SINGLE_SIGN_ON_SETUP': 'Single Sign On - Setup',
  'SKILLS': 'Skills',
  'SLACK_INTEGRATION': 'Slack Integration',
  'STANDALONE_WORKLOG_DIALOG': 'Standalone Worklog Dialog',
  'STRUCTURE_EMPTY_STATE': 'Structure Empty State',
  'TASK_VIEW': 'Task View',
  'TEAM_APPROVALS': 'Team Approvals',
  'TEAM_CAPACITY': 'Team Capacity',
  'TEAM_CLASSIFICATION': 'Team Classification',
  'TEAM_MEMBER_CAPACITY_REPORT': 'Team Member Capacity Report',
  'TEAM_MEMBERSHIP': 'Team Membership',
  'TEAM_OVERVIEW': 'Team Overview',
  'TEAM_PERMISSIONS': 'Team Permissions',
  'TEAM_PLANNING': 'Team Planning',
  'TEAM_ROLES': 'Team Roles',
  'TEAM_TIMESHEET': 'Team Timesheet',
  'TEAMS_CLASSIFICATION': 'Teams Classification',
  'TEAMS_OVERVIEW': 'Teams Overview',
  'TEMPLATE': 'Template',
  'TEMPO_ACCOUNTS': 'Tempo Accounts',
  'TEMPO_APPS': 'Tempo Apps',
  'TEMPO_ERROR': 'Tempo Error',
  'TEMPO_MY_WORK': 'Tempo My Work',
  'TEMPO_PROJECT_CONFIG': 'Tempo Project Config',
  'TEMPO_REPORTS': 'Tempo Reports',
  'TEMPO_TEAMS': 'Tempo Teams',
  'TIME_TRACKING_MODE': 'Time Tracking Mode',
  'TIMESHEETS': 'Timesheets',
  'TRACKER': 'Tracker',
  'TRIAL_SIGN_UP': 'Trial Sign Up',
  'UI_PREFERENCES': 'UI Preferences',
  'UPGRADE': 'Upgrade',
  'USER_APPROVAL_LOG': 'User Approval Log',
  'USER_APPROVAL_TIMESHEET': 'User Approval Timesheet',
  'USER_TIMESHEET': 'User Timesheet',
  'WORK_ATTRIBUTES': 'Work Attributes',
  'WORKLOAD': 'Workload',
  'WORKLOAD_SCHEME_MEMBERS': 'Workload Scheme Members',
  'WORKLOAD_SCHEMES': 'Workload Schemes',
  'WORKLOG_CALENDAR': 'Worklog Calendar',
  'WORKLOG_EDITOR_BULK_ACTIONS': 'Worklog Editor Bulk Actions',
  'WORKLOG_SYNC': 'Worklog Sync',
  'WORKSPACE': 'Workspace',
  'WORKSPACE_LIBRARY': 'Workspace -  Library',
  'WORKSPACE_BILLING_RATE_SHEETS_PROJECTS_USING': 'Workspace - Billing Rate Sheets - Projects Using',
  'WORKSPACE_BILLING_RATE_SHEETS_RULES': 'Workspace - Billing Rate Sheets - Rules',
  'WORKSPACE_COST_CODES': 'Workspace - Cost Codes',
  'WORKSPACE_CUSTOM_DATA': 'Workspace - Custom Data',
  'WORKSPACE_CUSTOMIZE_STATUS': 'Workspace - Customize Status',
  'WORKSPACE_DASHBOARD': 'Workspace - Dashboard',
  'WORKSPACE_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Changes Widget Click-through',
  'WORKSPACE_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Dashboard Note Widget Click-through',
  'WORKSPACE_DASHBOARD_DESIGN': 'Workspace - Dashboard - Design',
  'WORKSPACE_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Intake Widget Click-through',
  'WORKSPACE_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Workspace - Dashboard - Intake Widget Settings',
  'WORKSPACE_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - List Widget Click-through',
  'WORKSPACE_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Metrics Widget Click-through',
  'WORKSPACE_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Task Board Widget Click-through',
  'WORKSPACE_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Workload Widget Click-through',
  'WORKSPACE_PAY_RATE_SHEETS_PROJECTS_USING': 'Workspace - Pay Rate Sheets - Projects Using',
  'WORKSPACE_PAY_RATE_SHEETS_RULES': 'Workspace - Pay Rate Sheets - Rules',
  'WORKSPACE_RATE_SHEET_TABLE': 'Workspace - Rate Sheet Table',
  'WORKSPACE_REPORT': 'Workspace - Report',
  'WORKSPACE_REPORT_DESIGN': 'Workspace - Report - Design',
  'WORKSPACE_SETTINGS': 'Workspace - Settings',
  'ITERATIONS': 'Iterations',
  'PROJECT_NOT_FOUND': 'Project Not Found',
  'REPORT_NOT_FOUND': 'Report Not Found',
  'CUSTOM_FIELDS': 'Custom Fields',
  'CUSTOMERS': 'Customers',
  'IDEAS': 'Ideas',
  'INBOX': 'Inbox',
  'OVERVIEW': 'Overview',
  'PORTALS': 'Portals',
  'PRODUCT_AREAS': 'Product Areas',
  'BASE_APP_ONBOARDING': 'Base app onboarding',
  'COPY_TO_JIRA_HISTORY': 'Copy to Jira History',
  'CREATE': 'Create',
  'WELCOME': 'Welcome',
  'ONBOARDING': 'Onboarding',
  'ONBOARDING_GET_STARTED': 'Onboarding Get Started',
  'ONBOARDING_INTEGRATIONS': 'Onboarding Integrations',
  'ONBOARDING_PREFERENCE_AND_SETTINGS': 'Onboarding Preference and Settings',
  'ONBOARDING_TEAM_CREATIONS': 'Onboarding Team Creations',
  'QUICK_START_GUIDE': 'Quick Start Guide',
  'INSIGHTS_DASHBOARD': 'Insights Dashboard',
  'CUSTOM_CHARTS_HUB': 'Custom Charts Hub',
} as const;
export type OriginPageType = typeof OriginPage;
export type OriginPageValueType = OriginPageType[keyof OriginPageType];

export const RecAssignLens = {
  'BYYOU': 'byyou',
  'TOYOU': 'toyou',
} as const;
export type RecAssignLensType = typeof RecAssignLens;
export type RecAssignLensValueType = RecAssignLensType[keyof RecAssignLensType];

export const RecPriority = {
  'HIGH': 'high',
  'LOW': 'low',
  'MEDIUM': 'medium',
  'URGENT': 'urgent',
} as const;
export type RecPriorityType = typeof RecPriority;
export type RecPriorityValueType = RecPriorityType[keyof RecPriorityType];

export const RecScope = {
  'LOOP': 'loop',
  'ORG': 'org',
  'TEAM': 'team',
} as const;
export type RecScopeType = typeof RecScope;
export type RecScopeValueType = RecScopeType[keyof RecScopeType];

export const SyncDirection = {
  'PULL': 'pull',
  'PUSH': 'push',
} as const;
export type SyncDirectionType = typeof SyncDirection;
export type SyncDirectionValueType = SyncDirectionType[keyof SyncDirectionType];

export const RecFootnoteType = {
  'ALTERNATIVES': 'alternatives',
  'SOURCES': 'sources',
} as const;
export type RecFootnoteTypeType = typeof RecFootnoteType;
export type RecFootnoteTypeValueType = RecFootnoteTypeType[keyof RecFootnoteTypeType];

export const InstructionType = {
  'CAPACITY_UTILIZATION': 'capacity_utilization',
  'ESTIMATION_BUFFER': 'estimation_buffer',
  'PRIORITY_FLEXIBILITY': 'priority_flexibility',
} as const;
export type InstructionTypeType = typeof InstructionType;
export type InstructionTypeValueType = InstructionTypeType[keyof InstructionTypeType];

export const RecTimeHorizon = {
  'EPIC': 'epic',
  'HALFYEAR': 'halfyear',
  'NONE': 'none',
  'QUARTER': 'quarter',
  'SPRINT': 'sprint',
} as const;
export type RecTimeHorizonType = typeof RecTimeHorizon;
export type RecTimeHorizonValueType = RecTimeHorizonType[keyof RecTimeHorizonType];

export const InstructionValue = {
  'HIGH': 'high',
  'LOW': 'low',
  'MEDIUM': 'medium',
} as const;
export type InstructionValueType = typeof InstructionValue;
export type InstructionValueValueType = InstructionValueType[keyof InstructionValueType];

export const ResourceType = {
  'GENERIC': 'Generic',
  'TEAM': 'Team',
  'USER': 'User',
} as const;
export type ResourceTypeType = typeof ResourceType;
export type ResourceTypeValueType = ResourceTypeType[keyof ResourceTypeType];

export const GroupingDimension = {
  'INSIGHT_TYPE': 'insightType',
  'PORTFOLIO_IMPACT': 'portfolioImpact',
} as const;
export type GroupingDimensionType = typeof GroupingDimension;
export type GroupingDimensionValueType = GroupingDimensionType[keyof GroupingDimensionType];

export const PlanAccessSetting = {
  'OPEN': 'Open',
  'PRIVATE': 'Private',
} as const;
export type PlanAccessSettingType = typeof PlanAccessSetting;
export type PlanAccessSettingValueType = PlanAccessSettingType[keyof PlanAccessSettingType];

export const ViewMode = {
  'COMPACT': 'compact',
  'GRID': 'grid',
} as const;
export type ViewModeType = typeof ViewMode;
export type ViewModeValueType = ViewModeType[keyof ViewModeType];

export const OriginAction = {
  'ACTIVATING_INNOVATION': 'Activating innovation',
  'ADD': 'Add',
  'ADD_TEAM_MEMBER': 'Add Team Member',
  'ADD_WORKLOG_HEADER_CLICKED': 'Add Worklog Header Clicked',
  'ADD_WORKLOG_MODAL_CLICKED': 'Add Worklog Modal Clicked',
  'ADD_CARD': 'Add card',
  'ADD_COLUMN': 'Add column',
  'ADD_ISSUE_DIALOG': 'Add issue dialog',
  'ADD_MARKER': 'Add marker',
  'ADDED': 'Added',
  'ADDED_ACCOUNT_PROJECT_LINK': 'Added Account Project Link',
  'ADDED_APPLICATION': 'Added Application',
  'ADDED_BUDGET_MILESTONE': 'Added Budget Milestone',
  'ADDED_CHART': 'Added Chart',
  'ADDED_COLUMN': 'Added Column',
  'ADDED_EFFECTIVE_DATE_RATE': 'Added Effective Date Rate',
  'ADDED_FIXED_DAY_TO_HOLIDAY_SCHEME': 'Added Fixed Day to Holiday Scheme',
  'ADDED_FLOATING_DAY_TO_HOLIDAY_SCHEME': 'Added Floating Day to Holiday Scheme',
  'ADDED_PERMISSION_ROLE': 'Added Permission Role',
  'ADDED_PROJECT': 'Added Project',
  'ADDED_PROJECT_ATTRIBUTE': 'Added Project Attribute',
  'ADDED_PROJECT_LINK_TO_TEAM': 'Added Project Link to Team',
  'ADDED_SCHEDULING': 'Added Scheduling',
  'ADDED_SKILL': 'Added Skill',
  'ADDED_STORY_POINT': 'Added Story Point',
  'ADDED_TASK': 'Added Task',
  'ADDED_TEAM_MEMBER': 'Added Team Member',
  'ADDED_TEAM_MEMBERS_IN_BULK': 'Added Team Members In Bulk',
  'ADDED_TEAM_ROLE': 'Added Team Role',
  'ADDED_TEAMS': 'Added Teams',
  'ADDED_WORK_ATTRIBUTE': 'Added Work Attribute',
  'ALL_TAGS_CLEARED': 'All Tags Cleared',
  'ALLOW_DUPLICATION_DISABLED': 'Allow Duplication Disabled',
  'ALLOW_DUPLICATION_ENABLED': 'Allow Duplication Enabled',
  'ALLOWED': 'Allowed',
  'ANYWHERE': 'Anywhere',
  'APP_MENU': 'App menu',
  'APPLIED_ACCOUNT_RATES': 'Applied Account Rates',
  'APPLIED_GLOBAL_COST_RATE': 'Applied Global Cost Rate',
  'APPLY_FOREST_ACTION': 'Apply forest action',
  'APPROVED': 'Approved',
  'APPROVERS_ADDED': 'Approvers Added',
  'APPROVERS_REMOVED': 'Approvers Removed',
  'ASSIGNED_TO_TEAM': 'Assigned to Team',
  'AUTO_CREATE_CONFIGURATION': 'Auto-create configuration',
  'AUTOMATIC_UPDATE': 'Automatic Update',
  'BACKLOG_CARD_ACTION': 'Backlog card action',
  'BACKLOG_CLOSED': 'Backlog closed',
  'BACKLOG_LOADMORE': 'Backlog loadmore',
  'BACKLOG_OPENED': 'Backlog opened',
  'BACKLOG_REFRESH': 'Backlog refresh',
  'BOARDS': 'Boards',
  'BULK_DELETE': 'Bulk Delete',
  'BULK_EDIT': 'Bulk Edit',
  'BULK_MOVE': 'Bulk Move',
  'CHANGE_REPORT_DISPLAY_TO_OVERVIEW': 'Change Report Display to Overview',
  'CHANGE_BAR': 'Change bar',
  'CHANGE_TO_AVAILABILITY': 'Change to Availability',
  'CHANGE_TO_CARDS': 'Change to Cards',
  'CHANGE_TO_HOURS': 'Change to Hours',
  'CHANGE_TO_TOTAL_HOURS': 'Change to Total Hours',
  'CHANGED_ACCESS_TYPE': 'Changed Access type',
  'CHANGED_BREAKDOWN_METHOD': 'Changed Breakdown Method',
  'CHANGED_ISSUE_IN_REPORTS': 'Changed Issue in Reports',
  'CHANGED_MAX_DAYS_USERS_CAN_LOG_FUTURE_WORK': 'Changed Max Days Users Can Log Future Work',
  'CHANGED_MAX_HOURS_USERS_CAN_LOG_WORK_PER_DAY': 'Changed Max Hours Users Can Log Work per Day',
  'CHANGED_PRINT_REPORT_TO_LANDSCAPE': 'Changed Print Report to Landscape',
  'CHANGED_PRINT_REPORT_TO_PORTRAIT': 'Changed Print Report to Portrait',
  'CHANGED_PROGRAM_MANAGER': 'Changed Program Manager',
  'CHANGED_PROGRAM_TEAM': 'Changed Program Team',
  'CHANGED_PROJECT_SCOPE': 'Changed Project Scope',
  'CHANGED_REPORT_DATE_DISPLAY_TO_DAYS': 'Changed Report Date Display to Days',
  'CHANGED_REPORT_DATE_DISPLAY_TO_MONTHS': 'Changed Report Date Display to Months',
  'CHANGED_REPORT_DATE_DISPLAY_TO_QUARTERS': 'Changed Report Date Display to Quarters',
  'CHANGED_REPORT_DATE_DISPLAY_TO_WEEKS': 'Changed Report Date Display to Weeks',
  'CHANGED_SORTING': 'Changed Sorting',
  'CHANGED_TEAM': 'Changed Team',
  'CHANGED_TIME_UNIT': 'Changed Time Unit',
  'CHANGED_TIMELINE_TIME_UNIT': 'Changed Timeline Time Unit',
  'CHANGED_DATE_FORMAT': 'Changed date format',
  'CHANGED_DURATION_FORMAT': 'Changed duration format',
  'CHANGED_THE_FIRST_DAY_OF_WEEK': 'Changed the first day of week',
  'CHANGED_TIME_FORMAT': 'Changed time format',
  'CLEAR_DELAYS_AND_RUN_LEVELING': 'Clear Delays and Run Leveling',
  'CLICK_PROVIDE_FEEDBACK': 'Click Provide Feedback',
  'CLICK_COPY_LINK': 'Click copy link',
  'CLICK_SHARE_BUTTON': 'Click share button',
  'CLICK_SHARE_TOGGLE': 'Click share toggle',
  'CLICKED': 'Clicked',
  'CLICKED_ADD_ITEM_BUTTON': 'Clicked Add Item Button',
  'CLICKED_ALLOW': 'Clicked Allow',
  'CLICKED_APPLY_ON_PERIOD_NAVIGATION': 'Clicked Apply on Period Navigation',
  'CLICKED_APPROVAL_LOG': 'Clicked Approval Log',
  'CLICKED_APPROVE_BUTTON': 'Clicked Approve Button',
  'CLICKED_BILLING_RATES': 'Clicked Billing Rates',
  'CLICKED_BULK_TIME_RECORDS_EDITOR': 'Clicked Bulk Time Records Editor',
  'CLICKED_CANCEL': 'Clicked Cancel',
  'CLICKED_CARD_ON_CANVAS': 'Clicked Card on Canvas',
  'CLICKED_CONNECT': 'Clicked Connect',
  'CLICKED_CONTACT_SALES': 'Clicked Contact Sales',
  'CLICKED_CONTACT_US': 'Clicked Contact Us',
  'CLICKED_COST_RATES': 'Clicked Cost Rates',
  'CLICKED_DELETE_BUTTON': 'Clicked Delete Button',
  'CLICKED_DONT_ALLOW': 'Clicked Don\'t Allow',
  'CLICKED_HELP_CENTER': 'Clicked Help Center',
  'CLICKED_HORIZONTAL_COLLAPSE': 'Clicked Horizontal Collapse',
  'CLICKED_HORIZONTAL_EXPAND': 'Clicked Horizontal Expand',
  'CLICKED_HOURS': 'Clicked Hours',
  'CLICKED_LEARN_MORE': 'Clicked Learn More',
  'CLICKED_LOG_WORK_BUTTON': 'Clicked Log Work Button',
  'CLICKED_MY_WORK_IN_NAVIGATION_MENU': 'Clicked My Work in Navigation Menu',
  'CLICKED_NEW_IMPORTANT_INFO': 'Clicked New & Important Info',
  'CLICKED_OPEN_STRUCTURE': 'Clicked Open Structure',
  'CLICKED_PAUSE_BUTTON': 'Clicked Pause Button',
  'CLICKED_PLAN_TIME_BUTTON': 'Clicked Plan Time Button',
  'CLICKED_PLUS_BUTTON': 'Clicked Plus Button',
  'CLICKED_PROJECT_APPROVAL_TAB': 'Clicked Project Approval Tab',
  'CLICKED_PROJECT_TIME_APPROVALS': 'Clicked Project Time Approvals',
  'CLICKED_REJECT_BUTTON': 'Clicked Reject Button',
  'CLICKED_REOPEN_BUTTON': 'Clicked Reopen Button',
  'CLICKED_REPORTS_IN_NAVIGATION_MENU': 'Clicked Reports in Navigation Menu',
  'CLICKED_RESUME_BUTTON': 'Clicked Resume Button',
  'CLICKED_RETURN_TO_START_BUTTON': 'Clicked Return To Start Button',
  'CLICKED_REVIEW_TIME': 'Clicked Review Time',
  'CLICKED_SHOW_MORE': 'Clicked Show More',
  'CLICKED_SHOW_MY_WORK': 'Clicked Show My Work',
  'CLICKED_TECHNICAL_SUPPORT': 'Clicked Technical Support',
  'CLICKED_TEMPO_SETTINGS': 'Clicked Tempo Settings',
  'CLICKED_TEMPO_STATUS': 'Clicked Tempo Status',
  'CLICKED_UPGRADE': 'Clicked Upgrade',
  'CLICKED_VERTICAL_COLLAPSE': 'Clicked Vertical Collapse',
  'CLICKED_VERTICAL_EXPAND': 'Clicked Vertical Expand',
  'CLICKED_X_ON_FORM': 'Clicked X on Form',
  'CLICKED_IN_CELL': 'Clicked in Cell',
  'CLICKED_IN_TASK_PANEL': 'Clicked in Task Panel',
  'CLICKED_ON_ACADEMY': 'Clicked on Academy',
  'CLICKED_ON_ACCOUNT': 'Clicked on Account',
  'CLICKED_ON_ADD_EFFECTIVE_DATE_RATE': 'Clicked on Add Effective Date Rate',
  'CLICKED_ON_ADD_PROJECT': 'Clicked on Add Project',
  'CLICKED_ON_ADD_TEAMS_BUTTON': 'Clicked on Add Teams Button',
  'CLICKED_ON_ADMINISTRATION': 'Clicked on Administration',
  'CLICKED_ON_ARROW': 'Clicked on Arrow',
  'CLICKED_ON_BACK_ARROW': 'Clicked on Back Arrow',
  'CLICKED_ON_CANCEL_BUTTON': 'Clicked on Cancel Button',
  'CLICKED_ON_CANVAS': 'Clicked on Canvas',
  'CLICKED_ON_CANVAS_HEADER_BUTTON': 'Clicked on Canvas Header Button',
  'CLICKED_ON_CAPEX_LINK': 'Clicked on Capex Link',
  'CLICKED_ON_CELL': 'Clicked on Cell',
  'CLICKED_ON_CLOSE': 'Clicked on Close',
  'CLICKED_ON_CLOSE_BUTTON': 'Clicked on Close Button',
  'CLICKED_ON_CONFIRM': 'Clicked on Confirm',
  'CLICKED_ON_CREATE_BUTTON': 'Clicked on Create Button',
  'CLICKED_ON_CURRENT_LINK': 'Clicked on Current Link',
  'CLICKED_ON_DASHBOARD_PASSPORT': 'Clicked on Dashboard Passport',
  'CLICKED_ON_DATE': 'Clicked on Date',
  'CLICKED_ON_DAYS_BUTTON': 'Clicked on Days Button',
  'CLICKED_ON_DELETE_PORTFOLIO': 'Clicked on Delete Portfolio',
  'CLICKED_ON_DONT_SHOW_THIS_AGAIN': 'Clicked on Don\'t Show This Again',
  'CLICKED_ON_DROPDOWN': 'Clicked on Dropdown',
  'CLICKED_ON_EXPANDED_CELL': 'Clicked on Expanded Cell',
  'CLICKED_ON_EXPORT_BUTTON': 'Clicked on Export Button',
  'CLICKED_ON_FAVORITE': 'Clicked on Favorite',
  'CLICKED_ON_FILTER_PICKER': 'Clicked on Filter Picker',
  'CLICKED_ON_FORWARD_ARROW': 'Clicked on Forward Arrow',
  'CLICKED_ON_FULL_DESCRIPTION_LINK': 'Clicked on Full Description Link',
  'CLICKED_ON_GAP_SUGGESTION': 'Clicked on Gap Suggestion',
  'CLICKED_ON_GRACE_GRANTED_ITEM': 'Clicked on Grace Granted Item',
  'CLICKED_ON_GROUPING_FILTER': 'Clicked on Grouping Filter',
  'CLICKED_ON_HELP': 'Clicked on Help',
  'CLICKED_ON_INCLUDE_COMPLETED_PROJECT': 'Clicked on Include Completed Project',
  'CLICKED_ON_ISSUE_ACTIONS': 'Clicked on Issue Actions',
  'CLICKED_ON_ITERATIONS_LINK': 'Clicked on Iterations Link',
  'CLICKED_ON_LAST_LINK': 'Clicked on Last Link',
  'CLICKED_ON_LIBRARY': 'Clicked on Library',
  'CLICKED_ON_LOG_TIME_BUTTON': 'Clicked on Log Time button',
  'CLICKED_ON_LOG_WORK_LINK_FROM_DROPDOWN': 'Clicked on Log Work Link from Dropdown',
  'CLICKED_ON_MOVE_LINK': 'Clicked on Move Link',
  'CLICKED_ON_MY_DISCUSSIONS': 'Clicked on My Discussions',
  'CLICKED_ON_MY_FAVORITES': 'Clicked on My Favorites',
  'CLICKED_ON_MY_WORK': 'Clicked on My Work',
  'CLICKED_ON_NOTIFICATION_LINK': 'Clicked on Notification Link',
  'CLICKED_ON_OPEX_LINK': 'Clicked on Opex Link',
  'CLICKED_ON_PEOPLE': 'Clicked on People',
  'CLICKED_ON_PLAN': 'Clicked on Plan',
  'CLICKED_ON_PORTFOLIO_LINK_PROJECT': 'Clicked on Portfolio Link - Project',
  'CLICKED_ON_PORTFOLIO_TILE': 'Clicked on Portfolio Tile',
  'CLICKED_ON_PREMIUM_FEATURES_TRIAL': 'Clicked on Premium Features Trial',
  'CLICKED_ON_PRINT_BUTTON_IN_LANDSCAPE_MODE': 'Clicked on Print Button in Landscape mode',
  'CLICKED_ON_PRINT_BUTTON_IN_PORTRAIT_MODE': 'Clicked on Print Button in Portrait mode',
  'CLICKED_ON_PROJECT_STATUS': 'Clicked on Project Status',
  'CLICKED_ON_PROJECTS': 'Clicked on Projects',
  'CLICKED_ON_QUICK_ACTION': 'Clicked on Quick Action',
  'CLICKED_ON_RE_IMPORT_SCOPE': 'Clicked on Re-Import Scope',
  'CLICKED_ON_REMOVE_PROJECT': 'Clicked on Remove Project',
  'CLICKED_ON_REMOVE_TEAMS_BUTTON': 'Clicked on Remove Teams Button',
  'CLICKED_ON_REVIEW_ALL': 'Clicked on Review All',
  'CLICKED_ON_SHARE_BUTTON': 'Clicked on Share Button',
  'CLICKED_ON_SKIP': 'Clicked on Skip',
  'CLICKED_ON_SUBMIT_BUTTON': 'Clicked on Submit Button',
  'CLICKED_ON_SUBSCRIBE': 'Clicked on Subscribe',
  'CLICKED_ON_TEAM_MEMBER_LINK': 'Clicked on Team Member Link',
  'CLICKED_ON_TIME_AXIS': 'Clicked on Time Axis',
  'CLICKED_ON_TIMERECORD': 'Clicked on TimeRecord',
  'CLICKED_ON_TIMESHEET': 'Clicked on TimeSheet',
  'CLICKED_ON_TIMESHEET_DUE': 'Clicked on Timesheet Due',
  'CLICKED_ON_TODAY_BUTTON': 'Clicked on Today Button',
  'CLICKED_ON_TODAY_LINK': 'Clicked on Today Link',
  'CLICKED_ON_ULTIMATE_TRIAL': 'Clicked on Ultimate Trial',
  'CLICKED_ON_VIEW_REPORT': 'Clicked on View Report',
  'CLICKED_ON_WEEK_HEADER': 'Clicked on Week Header',
  'CLICKED_ON_WEEKS_BUTTON': 'Clicked on Weeks Button',
  'CLICKED_ON_WORKSPACE_LINK': 'Clicked on Workspace Link',
  'CLICKED_ON_EFFORT_TYPES_TO_FILTER_DATA': 'Clicked on effort types to filter data',
  'CLICKED_ON_TITLE_TO_VIEW_REPORT': 'Clicked on title to view report',
  'CLOSED_PERIOD_FOR_ALL': 'Closed Period for All',
  'COLLAPSE_ALL': 'Collapse all',
  'COLLAPSE_NEXT_LEVEL': 'Collapse next level',
  'COLLAPSED': 'Collapsed',
  'COLLAPSED_CHART': 'Collapsed Chart',
  'COLUMN_VALUE_RESOLUTION_TASK': 'Column value resolution task',
  'COMMAND_LINE': 'Command Line',
  'COMPRESS_ROWS': 'Compress Rows',
  'COMPRESSED_CARDS': 'Compressed Cards',
  'CONFIGURE': 'Configure',
  'CONNECT': 'Connect',
  'CONVERTED_GOOGLE_CAL_EVENT': 'Converted Google Cal Event',
  'CONVERTED_OFFICE_365_CAL_EVENT': 'Converted Office 365 Cal Event',
  'CONVERTED_PLAN': 'Converted Plan',
  'CONVERTED_SUGGESTION': 'Converted Suggestion',
  'CONVERTED_TRACKER': 'Converted Tracker',
  'CONVERTED_FROM_SUGGESTION': 'Converted from Suggestion',
  'COPIED_PLAN': 'Copied Plan',
  'COPIED_TIME_RECORD': 'Copied Time Record',
  'COPIED_WORKLOG': 'Copied Worklog',
  'COPY': 'Copy',
  'CREATE_NEW_CHART': 'Create New Chart',
  'CREATE_NEW_ISSUE_LIST': 'Create New Issue List',
  'CREATE_NEW_SIMPLE_SEARCH': 'Create New Simple Search',
  'CREATE_BASELINE': 'Create baseline',
  'CREATE_CONFIGURATION': 'Create configuration',
  'CREATE_DEPENDENCY': 'Create dependency',
  'CREATE_FOLDER_DIALOG': 'Create folder dialog',
  'CREATE_LINK': 'Create link',
  'CREATE_MILESTONE': 'Create milestone',
  'CREATE_STATUS': 'Create status',
  'CREATE_STRUCTURE': 'Create structure',
  'CREATED_CATEGORY': 'Created Category',
  'CREATED_CUSTOMER': 'Created Customer',
  'CREATED_EXPENSE': 'Created Expense',
  'CREATED_NEW_TOKEN': 'Created New Token',
  'CREATED_NEW_TRACKER': 'Created New Tracker',
  'CREATED_PROJECT_GROUP': 'Created Project Group',
  'CREATED_ROLE': 'Created Role',
  'CREATED_SKILL': 'Created Skill',
  'CREATED_TAG': 'Created Tag',
  'CREATED_FROM_TRACKER': 'Created from Tracker',
  'CUT': 'Cut',
  'DASHBOARD_ITEM': 'Dashboard item',
  'DEACTIVATING_INNOVATION': 'Deactivating innovation',
  'DELETE': 'Delete',
  'DELETE_ENTIRE_PLAN': 'Delete Entire Plan',
  'DELETE_ENTIRE_RECURRING_PLAN_SERIES': 'Delete Entire Recurring Plan Series',
  'DELETE_PARTIAL_PLAN': 'Delete Partial Plan',
  'DELETE_BY_SWIPING': 'Delete by Swiping',
  'DELETE_LINK': 'Delete link',
  'DELETE_STATUS': 'Delete status',
  'DELETE_SUBTREE': 'Delete subtree',
  'DELETE_THIS_AND_UPCOMING_FROM_REPEATED_PLAN_SERIES': 'Delete this and upcoming from repeated plan series',
  'DELETED': 'Deleted',
  'DELETED_CATEGORY': 'Deleted Category',
  'DELETED_CUSTOMER': 'Deleted Customer',
  'DELETED_EFFECTIVE_DATE_RATE': 'Deleted Effective Date Rate',
  'DELETED_EXPENSE': 'Deleted Expense',
  'DELETED_PERMISSION_ROLE': 'Deleted Permission Role',
  'DELETED_ROLE': 'Deleted Role',
  'DELETED_SKILL': 'Deleted Skill',
  'DELETED_TAG': 'Deleted Tag',
  'DELETED_TEAM_MEMBER': 'Deleted Team Member',
  'DELETED_TOKEN': 'Deleted Token',
  'DELETED_WORK_ATTRIBUTE': 'Deleted Work Attribute',
  'DEPICTION_CHANGE': 'Depiction Change',
  'DETAILS_EDITED': 'Details Edited',
  'DISABLE': 'Disable',
  'DISABLE_TRANSFORMATION': 'Disable Transformation',
  'DISABLED_ACCOUNT_GLOBAL': 'Disabled Account Global',
  'DISABLED_ACCOUNT_RATES': 'Disabled Account Rates',
  'DISABLED_DELETE_PLANS_WHEN_ASSOCIATED_ISSUES_ARE_DELETED': 'Disabled Delete plans when associated issues are deleted',
  'DISABLED_GLOBAL_COST_RATE': 'Disabled Global Cost Rate',
  'DISABLED_LOGGING_ON_CLOSED_AND_ARCHIVED_ACCOUNTS': 'Disabled Logging on Closed and Archived Accounts',
  'DISABLED_PLAN_APPROVAL': 'Disabled Plan Approval',
  'DISABLED_PROJECT_TIME_APPROVAL': 'Disabled Project Time Approval',
  'DISABLED_REVENUE_TRACKING': 'Disabled Revenue Tracking',
  'DISABLED_SHOW_USERS_WITH_ZERO_HOURS': 'Disabled Show Users With Zero Hours',
  'DISABLED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Disabled Sync Plans With Jira Issues',
  'DISABLED_OVERRIDE_CLOSED_PERIODS_AND_APPROVED_TIMESHEETS': 'Disabled override closed periods and approved timesheets',
  'DISCONNECT': 'Disconnect',
  'DRAGGED_PLAN_AROUND_CANVAS': 'Dragged Plan around Canvas',
  'DRAGGED_SUGGESTION_ON_CANVAS': 'Dragged Suggestion on Canvas',
  'DRAGGED_SUGGESTION_TO_CANVAS': 'Dragged Suggestion to Canvas',
  'DRAGGED_WORKLOG': 'Dragged Worklog',
  'DRAGGED_WORKLOG_AROUND_CANVAS': 'Dragged Worklog around Canvas',
  'DRAGGED_ISSUE_TO_AVAILABLE_DATE_IN_WEEKS_VIEW': 'Dragged issue to available date in weeks view',
  'DUPLICATED': 'Duplicated',
  'DUPLICATED_ITEM_FROM_TABLE_VALUE': 'Duplicated Item from Table Value',
  'EDIT': 'Edit',
  'EDIT_SUGGESTION': 'Edit Suggestion',
  'EDITED_ACCOUNT_CATEGORY': 'Edited Account Category',
  'EDITED_ACCOUNT_CONTACT': 'Edited Account Contact',
  'EDITED_ACCOUNT_CUSTOMER': 'Edited Account Customer',
  'EDITED_ACCOUNT_LEAD': 'Edited Account Lead',
  'EDITED_ACCOUNT_MONTHLY_BUDGET': 'Edited Account Monthly Budget',
  'EDITED_ACCOUNT_NAME': 'Edited Account Name',
  'EDITED_ACCOUNT_STATUS': 'Edited Account Status',
  'EDITED_APPLICATION': 'Edited Application',
  'EDITED_CATEGORY': 'Edited Category',
  'EDITED_COLOR_TAG': 'Edited Color-Tag',
  'EDITED_CUSTOMER': 'Edited Customer',
  'EDITED_DATE': 'Edited Date',
  'EDITED_DATE_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Date for a Holiday Scheme Configuration',
  'EDITED_DESCRIPTION': 'Edited Description',
  'EDITED_DESCRIPTION_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Description for a Holiday Scheme Configuration',
  'EDITED_DURATION': 'Edited Duration',
  'EDITED_DURATION_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Duration for a Holiday Scheme Configuration',
  'EDITED_NAME': 'Edited Name',
  'EDITED_NAME_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Name for a Holiday Scheme Configuration',
  'EDITED_PERMISSION_ROLE': 'Edited Permission Role',
  'EDITED_PLAN_IN_FORM': 'Edited Plan in Form',
  'EDITED_PORTFOLIO_COLOR_TAG': 'Edited Portfolio Color Tag',
  'EDITED_PORTFOLIO_DESCRIPTION': 'Edited Portfolio Description',
  'EDITED_PORTFOLIO_NAME': 'Edited Portfolio Name',
  'EDITED_ROLE': 'Edited Role',
  'EDITED_ROLE_SET_DEFAULT': 'Edited Role Set Default',
  'EDITED_SKILL': 'Edited Skill',
  'EDITED_TEAM_LEAD': 'Edited Team Lead',
  'EDITED_TEAM_MEMBER': 'Edited Team Member',
  'EDITED_TEAM_NAME': 'Edited Team Name',
  'EDITED_TEAM_PROGRAM': 'Edited Team Program',
  'EDITED_TEAM_ROLE': 'Edited Team Role',
  'EDITED_TEAM_SUMMARY': 'Edited Team Summary',
  'EDITED_TEAM_TYPE': 'Edited Team Type',
  'EDITED_TOKEN': 'Edited Token',
  'EDITED_WORK_ATTRIBUTE': 'Edited Work Attribute',
  'EDITED_WORKLOAD_SCHEME': 'Edited Workload Scheme',
  'EDITED_WORKLOAD_SCHEME_ADDED_MEMBER': 'Edited Workload Scheme Added Member',
  'EDITED_WORKLOAD_SCHEME_DESCRIPTION': 'Edited Workload Scheme Description',
  'EDITED_WORKLOAD_SCHEME_HOURS': 'Edited Workload Scheme Hours',
  'EDITED_WORKLOAD_SCHEME_MOVED_MEMBER': 'Edited Workload Scheme Moved Member',
  'EDITED_WORKLOAD_SCHEME_NAME': 'Edited Workload Scheme Name',
  'EDITED_WORKLOAD_SCHEME_SET_DEFAULT': 'Edited Workload Scheme Set Default',
  'EDITED_FOLDER_DIALOG': 'Edited folder dialog',
  'EDITED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Edited sync plans with Jira issues',
  'EDITED_SYNC_TEAM_PLANS_WITH_JIRA_ISSUES': 'Edited sync team plans with Jira issues',
  'ENABLE': 'Enable',
  'ENABLE_TRANSFORMATION': 'Enable Transformation',
  'ENABLED_ACCOUNT_GLOBAL': 'Enabled Account Global',
  'ENABLED_DELETE_PLANS_WHEN_ASSOCIATED_ISSUES_ARE_DELETED': 'Enabled Delete plans when associated issues are deleted',
  'ENABLED_LOGGING_ON_CLOSED_AND_ARCHIVED_ACCOUNTS': 'Enabled Logging on Closed and Archived Accounts',
  'ENABLED_PLAN_APPROVAL': 'Enabled Plan Approval',
  'ENABLED_PROJECT_TIME_APPROVAL': 'Enabled Project Time Approval',
  'ENABLED_REVENUE_TRACKING': 'Enabled Revenue Tracking',
  'ENABLED_SHOW_USERS_WITH_ZERO_HOURS': 'Enabled Show Users With Zero Hours',
  'ENABLED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Enabled Sync Plans With Jira Issues',
  'ENABLED_OVERRIDE_CLOSED_PERIODS_AND_APPROVED_TIMESHEETS': 'Enabled override closed periods and approved timesheets',
  'EXCLUDED_COMPLETED_PROJECTS': 'Excluded Completed Projects',
  'EXPAND_ROWS': 'Expand Rows',
  'EXPAND_SUGGESTION': 'Expand Suggestion',
  'EXPAND_ALL': 'Expand all',
  'EXPAND_LEVEL': 'Expand level',
  'EXPAND_NEXT_LEVEL': 'Expand next level',
  'EXPANDED': 'Expanded',
  'EXPANDED_CARD_ON_CANVAS': 'Expanded Card on Canvas',
  'EXPANDED_CARDS': 'Expanded Cards',
  'EXPANDED_CHART': 'Expanded Chart',
  'EXPORTED_ACCOUNTS': 'Exported Accounts',
  'EXPORTED_DETAILED_ACTUALS_DATA': 'Exported Detailed Actuals Data',
  'EXPORTED_DETAILED_PLANNED_DATA': 'Exported Detailed Planned Data',
  'EXPORTED_EXPENSES_ACTUALS_DATA': 'Exported Expenses Actuals Data',
  'EXPORTED_LABOR_DATA': 'Exported Labor Data',
  'EXPORTED_PORTFOLIO_SUMMARY': 'Exported Portfolio Summary',
  'EXPORTED_TASK_ACTUALS_DATA': 'Exported Task Actuals Data',
  'FACTOR_SET_AS_DIVISOR': 'Factor set as divisor',
  'FACTOR_WEIGHT_CHANGED': 'Factor weight changed',
  'FAVORITED': 'Favorited',
  'FILTER_SELECTED': 'Filter Selected',
  'FILTER_STRUCTURE_SEARCH_BAR': 'Filter structure search bar',
  'FILTERS_CLEARED': 'Filters Cleared',
  'GENERATOR': 'Generator',
  'GLOBAL_BILLING_RATE_CHANGED': 'Global Billing Rate Changed',
  'GLOBAL_COST_RATE_CHANGED': 'Global Cost Rate Changed',
  'GO_TO_INTERNAL_ISSUES': 'Go to internal Issues',
  'GROUP_BY_TIME': 'Group by Time',
  'GROUPED_TASKS_BY_EPICS': 'Grouped Tasks by Epics',
  'HIDE_ACTIVITY_PROVIDER': 'Hide Activity Provider',
  'HIDE_CALENDAR_EVENTS': 'Hide Calendar Events',
  'HIDE_CAPACITY_INDICATORS': 'Hide Capacity Indicators',
  'HIDE_GENERIC_PLANS': 'Hide Generic Plans',
  'HIDE_INCOMPLETE_ACTIVITY': 'Hide Incomplete Activity',
  'HIDE_ISSUES_SIDE_PANEL': 'Hide Issues Side Panel',
  'HIDE_KPI_PANEL': 'Hide KPI Panel',
  'HIDE_LARGE_CARDS': 'Hide Large Cards',
  'HIDE_PLANS': 'Hide Plans',
  'HIDE_REJECTED_ACTIVITY': 'Hide Rejected Activity',
  'HIDE_REJECTED_PLANS': 'Hide Rejected Plans',
  'HIDE_SKILLS': 'Hide Skills',
  'HIDE_WEEKENDS': 'Hide Weekends',
  'HIDE_SEARCH_BAR_PANEL': 'Hide search bar panel',
  'HIDE_TRANSFORMATION_PANEL': 'Hide transformation panel',
  'HORIZONTAL_SCROLL_DISABLED': 'Horizontal scroll disabled',
  'HORIZONTAL_SCROLL_ENABLED': 'Horizontal scroll enabled',
  'HOVER_ON_ACCOUNT_SETUP': 'Hover on Account Setup',
  'HOVERED_ON_UNCATEGORIZED': 'Hovered on Uncategorized',
  'IMPORT_MACRO': 'Import Macro',
  'IMPORT_CONFIGURATION': 'Import configuration',
  'IMPORT_FROM_JIRA': 'Import from Jira',
  'IMPORTED_ACCOUNTS': 'Imported Accounts',
  'IMPORTED_PROJECT_SCOPE': 'Imported Project Scope',
  'IN_PROGRESS_ISSUES': 'In Progress Issues',
  'INCLUDED_COMPLETED_PROJECTS': 'Included Completed Projects',
  'INLINE_EDITING': 'Inline Editing',
  'INLINE_CREATION': 'Inline creation',
  'INPUT_VALUE_INTO_ITEM_TABLE': 'Input Value Into Item Table',
  'INTERACTIVE_FORM': 'Interactive Form',
  'ITEM_DETAILS_EDITED': 'Item Details Edited',
  'ITEM_DUPLICATED': 'Item Duplicated',
  'ITEM_MOVED': 'Item Moved',
  'ITEM_REPOSITIONED': 'Item Repositioned',
  'LEVEL_DOWN': 'Level down',
  'LEVEL_UP': 'Level up',
  'LOCK_COLOR_PALETTE_DISABLED': 'Lock Color Palette Disabled',
  'LOCK_COLOR_PALETTE_ENABLED': 'Lock Color Palette Enabled',
  'LOG_ALL_ACTIVITIES': 'Log All Activities',
  'LOG_ALL_DAILY_ACTIVITIES': 'Log All Daily Activities',
  'LOG_ALL_SUGGESTIONS': 'Log All Suggestions',
  'LOG_SUGGESTION': 'Log Suggestion',
  'MADE_REMAINING_ESTIMATE_OPTIONAL': 'Made Remaining Estimate Optional',
  'MADE_REMAINING_ESTIMATE_REQUIRED': 'Made Remaining Estimate Required',
  'MADE_START_AND_END_TIMES_DISABLED': 'Made Start And End Times Disabled',
  'MADE_START_AND_END_TIMES_ENABLED': 'Made Start And End Times Enabled',
  'MADE_START_AND_END_TIMES_FOR_PLANNING_DISABLED': 'Made Start And End Times For Planning Disabled',
  'MADE_START_AND_END_TIMES_FOR_PLANNING_ENABLED': 'Made Start And End Times For Planning Enabled',
  'MADE_TEAM_ADMINISTRATIVE': 'Made Team Administrative',
  'MADE_TEAM_SELF_MANAGED': 'Made Team Self Managed',
  'MADE_WORKLOG_DESCRIPTION_OPTIONAL': 'Made Worklog Description Optional',
  'MADE_WORKLOG_DESCRIPTION_REQUIRED': 'Made Worklog Description Required',
  'MANUAL_UPDATE': 'Manual update',
  'MEMBERS_ADDED': 'Members Added',
  'MEMBERS_REMOVED': 'Members Removed',
  'MODIFIED_BUDGET_MILESTONE': 'Modified Budget Milestone',
  'MODIFIED_DEFAULT_BILLING_RATE': 'Modified Default Billing Rate',
  'MODIFIED_DEFAULT_COST_RATE': 'Modified Default Cost Rate',
  'MODIFIED_EXPENSE': 'Modified Expense',
  'MODIFIED_INDIVIDUAL_BILLING_RATE': 'Modified Individual Billing Rate',
  'MODIFIED_INDIVIDUAL_COST_RATE': 'Modified Individual Cost Rate',
  'MODIFIED_PROJECT_ATTRIBUTE_VALUE': 'Modified Project Attribute Value',
  'MODIFIED_PROJECT_BUDGET': 'Modified Project Budget',
  'MODIFIED_PROJECT_CURRENCY': 'Modified Project Currency',
  'MODIFIED_PROJECT_NAME': 'Modified Project Name',
  'MODIFIED_PROJECT_STATUS': 'Modified Project Status',
  'MODIFIED_PROJECT_TIMEFRAME': 'Modified Project Timeframe',
  'MODIFIED_PROJECT_TYPE': 'Modified Project Type',
  'MODIFIED_SCOPE_ORDER': 'Modified Scope Order',
  'MODIFIED_TEAM_MEMBER_ROLE': 'Modified Team Member Role',
  'MODIFY_NAME': 'Modify Name',
  'MODIFY_PLAN': 'Modify Plan',
  'MOVE': 'Move',
  'MOVE_TEAM_MEMBER': 'Move Team Member',
  'MOVE_CARD': 'Move card',
  'MOVE_COLUMN': 'Move column',
  'MOVE_DOWN': 'Move down',
  'MOVE_UP': 'Move up',
  'MOVED_CARD_ON_CANVAS': 'Moved Card on Canvas',
  'MOVED_TASKS_TO_A_GROUP': 'Moved Tasks to a Group',
  'MULTIPLE_ATTRIBUTES_CHANGED': 'Multiple Attributes Changed',
  'NEW_ITEM': 'New Item',
  'NEW_ITEM_BELOW': 'New Item Below',
  'NEW_PLAN': 'New Plan',
  'NEW_SUB_ITEM': 'New Sub Item',
  'NEW_SUB_ITEM_BELOW': 'New Sub Item Below',
  'NOT_ALLOWED': 'Not Allowed',
  'ON_ARROW_DOWN': 'On Arrow Down',
  'ON_ARROW_UP': 'On Arrow Up',
  'ON_BLUR': 'On Blur',
  'ON_ENTER': 'On ENTER',
  'ON_ESCAPE': 'On ESCAPE',
  'ONBOARDING_MESSAGE': 'Onboarding Message',
  'OPENED_PERIOD_FOR_ALL': 'Opened Period for All',
  'OPENED_PERIOD_FOR_TIMESHEET_APPROVERS': 'Opened Period for Timesheet Approvers',
  'OPENED_PUSH_NOTIFICATION': 'Opened Push Notification',
  'PASTE': 'Paste',
  'PERIOD_CELL_SELECT': 'Period Cell Select',
  'PIN': 'Pin',
  'PIN_COLUMN': 'Pin column',
  'PINNED': 'Pinned',
  'PINNED_PORTFOLIO': 'Pinned Portfolio',
  'PINNED_REPORT': 'Pinned Report',
  'PRESSED_KEYBOARD_SHORTCUT': 'Pressed Keyboard Shortcut',
  'PROJECT_OVERVIEW': 'Project overview',
  'PROJECTS': 'Projects',
  'PULLED_FROM_JIRA': 'Pulled from Jira',
  'REASSIGN_PLANS': 'Reassign Plans',
  'REFRESH_PANELS': 'Refresh panels',
  'REGENERATED_TOKEN': 'Regenerated Token',
  'REJECTED': 'Rejected',
  'REMOVE': 'Remove',
  'REMOVE_BASELINE': 'Remove baseline',
  'REMOVE_COLUMN': 'Remove column',
  'REMOVE_DEPENDENCY': 'Remove dependency',
  'REMOVE_MARKER': 'Remove marker',
  'REMOVE_MILESTONE': 'Remove milestone',
  'REMOVED': 'Removed',
  'REMOVED_ACCOUNT_PROJECT_LINK': 'Removed Account Project Link',
  'REMOVED_BUDGET_MILESTONE': 'Removed Budget Milestone',
  'REMOVED_CHART': 'Removed Chart',
  'REMOVED_COLUMN': 'Removed Column',
  'REMOVED_FIXED_DAY_FROM_HOLIDAY_SCHEME': 'Removed Fixed Day from Holiday Scheme',
  'REMOVED_FLOATING_DAY_FROM_HOLIDAY_SCHEME': 'Removed Floating Day from Holiday Scheme',
  'REMOVED_GROUPING': 'Removed Grouping',
  'REMOVED_PROJECT': 'Removed Project',
  'REMOVED_PROJECT_ATTRIBUTE': 'Removed Project Attribute',
  'REMOVED_PROJECT_LINK_FROM_TEAM': 'Removed Project Link from Team',
  'REMOVED_SKILL': 'Removed Skill',
  'REMOVED_STORY_POINT': 'Removed Story Point',
  'REMOVED_TASK': 'Removed Task',
  'REMOVED_TEAM_ROLE': 'Removed Team Role',
  'REMOVED_TEAMS': 'Removed Teams',
  'RENAMED_PROGRAM': 'Renamed Program',
  'RENAMED_REPORT': 'Renamed Report',
  'REORDER_STATUSES': 'Reorder statuses',
  'REPLACED_WORKLOG': 'Replaced Worklog',
  'RESET_LEVELING': 'Reset Leveling',
  'RESIZED_PLAN': 'Resized Plan',
  'RESIZED_WORKLOG': 'Resized Worklog',
  'RESIZED_WORKLOG_IN_CALENDAR_VIEW': 'Resized Worklog in Calendar View',
  'REVERTED_TO_CALCULATED_TIMEFRAME': 'Reverted to Calculated Timeframe',
  'REVERTED_TO_A_SINGLE_BUDGET': 'Reverted to a Single Budget',
  'REVOKED_APPLICATION': 'Revoked Application',
  'ROADMAP_ADDED': 'Roadmap Added',
  'ROADMAP_REMOVED': 'Roadmap Removed',
  'ROADMUNK_LINK': 'Roadmunk link',
  'RUN_LEVELING': 'Run Leveling',
  'SEARCH_DIALOG': 'Search dialog',
  'SELECT_AGGREGATE_MODE': 'Select aggregate mode',
  'SELECT_DEPENDENCIES': 'Select dependencies',
  'SELECT_TEAMS': 'Select teams',
  'SELECTED_GANTT': 'Selected Gantt',
  'SELECTED_ISSUE_FOR_TRACKER': 'Selected Issue For Tracker',
  'SELECTED_PLANNER': 'Selected Planner',
  'SELECTED_PROJECT': 'Selected Project',
  'SELECTED_SPECIFIC_DATES': 'Selected Specific Dates',
  'SELECTED_TEAM': 'Selected Team',
  'SELECTED_FROM_DROPDOWN_MENU': 'Selected from Dropdown Menu',
  'SELECTOR': 'Selector',
  'SET_APPROVER_AS_DEFAULT': 'Set Approver as Default',
  'SET_DEFAULT_TEAM_ROLE': 'Set Default Team Role',
  'SET_PROGRAM_MANAGER': 'Set Program Manager',
  'SET_AS_DEFAULT': 'Set as Default',
  'SET_AS_DEFAULT_WORKSPACE': 'Set as Default Workspace',
  'SET_ESTIMATE_LIMIT': 'Set estimate limit',
  'SET_TO_AUTOMATIC_MODE': 'Set to Automatic Mode',
  'SET_TO_DAILY_SUMMARY_JIRA_WORKLOG_FOR_MULTIPLE_TEMPO_WORKLOGS': 'Set to Daily Summary Jira worklog for multiple Tempo worklogs',
  'SET_TO_ONE_JIRA_WORKLOG_PER_TEMPO_WORKLOG': 'Set to One Jira Worklog per Tempo worklog',
  'SET_TO_REMINDER_MODE': 'Set to Reminder Mode',
  'SET_TO_STANDARD_MODE': 'Set to Standard Mode',
  'SHARE_LINK': 'Share link',
  'SHOW_ACTIVITY_PROVIDER': 'Show Activity Provider',
  'SHOW_CALENDAR_EVENTS': 'Show Calendar Events',
  'SHOW_CAPACITY_INDICATORS': 'Show Capacity Indicators',
  'SHOW_GENERIC_PLANS': 'Show Generic Plans',
  'SHOW_INCOMPLETE_ACTIVITY': 'Show Incomplete Activity',
  'SHOW_ISSUES_SIDE_PANEL': 'Show Issues Side Panel',
  'SHOW_KPI_PANEL': 'Show KPI Panel',
  'SHOW_LARGE_CARDS': 'Show Large Cards',
  'SHOW_REJECTED_ACTIVITY': 'Show Rejected Activity',
  'SHOW_REJECTED_PLANS': 'Show Rejected Plans',
  'SHOW_SKILLS': 'Show Skills',
  'SHOW_WEEKENDS': 'Show Weekends',
  'SHOW_SEARCH_BAR_PANEL': 'Show search bar panel',
  'SHOW_TRANSFORMATION_PANEL': 'Show transformation panel',
  'SORT_BY_START_TIME': 'Sort by Start time',
  'SORT_COLUMN': 'Sort column',
  'SPLIT_PLAN': 'Split Plan',
  'SPLIT_WORKLOG': 'Split Worklog',
  'STARTED_AUTOMATICALLY': 'Started Automatically',
  'STATUS_OVERVIEW': 'Status overview',
  'STORY_POINT_SCHEME_DELETED': 'Story Point Scheme Deleted ',
  'STRUCTURE_WIZARD': 'Structure wizard',
  'SUGGESTED': 'Suggested',
  'SWIMLANE_BETA_DISABLED': 'Swimlane Beta Disabled',
  'SWIMLANE_BETA_ENABLED': 'Swimlane Beta Enabled',
  'SWIPE': 'Swipe',
  'SYNCED_PROJECT_SCOPE': 'Synced Project Scope',
  'SYNCHRONIZE': 'Synchronize',
  'TAG_REMOVED_FROM_PROJECT': 'Tag Removed from Project',
  'TAGS_ADDED_TO_PROJECT': 'Tags Added to Project',
  'TAKE_A_GUIDED_TOUR': 'Take a Guided Tour',
  'TEAM_PROPERTIES_CHANGED': 'Team Properties Changed',
  'TEMPO_PLANNED_TIME_SPEC_CHANGE': 'Tempo planned time spec change',
  'TEMPO_WORKLOG_SPEC_CHANGE': 'Tempo worklog spec change',
  'TEST_RUN_SET_DISPLAY_PARAMS': 'Test run set display params',
  'TEST_RUN_SET_NOTES': 'Test run set notes',
  'TEST_RUN_SET_STATUS': 'Test run set status',
  'TEXT_WRAP_DISABLED': 'Text wrap disabled',
  'TEXT_WRAP_ENABLED': 'Text wrap enabled',
  'TOGGLE_AUTOMATION': 'Toggle automation',
  'TOGGLE_EDIT_MODE': 'Toggle edit mode',
  'TRANSFORMATION_APPLIED': 'Transformation applied',
  'TRANSFORMATION_DISABLED': 'Transformation disabled',
  'TURNED_OFF': 'Turned Off',
  'TURNED_OFF_PORTFOLIO_SHARING': 'Turned Off Portfolio Sharing',
  'TURNED_ON': 'Turned On',
  'TURNED_ON_PORTFOLIO_SHARING': 'Turned On Portfolio Sharing',
  'TURNING_OFF_AUTOMATIC_ENABLEMENT': 'Turning off automatic enablement',
  'TURNING_ON_AUTOMATIC_ENABLEMENT': 'Turning on automatic enablement',
  'TUTORIAL_AND_FEATURES': 'Tutorial and Features',
  'UNDO': 'Undo',
  'UNFAVORITED': 'Unfavorited',
  'UNHIDE_PLANS': 'Unhide Plans',
  'UNPIN': 'Unpin',
  'UNPIN_COLUMN': 'Unpin column',
  'UNPINNED': 'Unpinned',
  'UNPINNED_PORTFOLIO': 'Unpinned Portfolio',
  'UNPINNED_REPORT': 'Unpinned Report',
  'UPDATE': 'Update',
  'UPDATE_AUTO_SYNC_SCOPE_SCHEDULE': 'Update Auto-Sync Scope Schedule',
  'UPDATE_BACKLOG_QUERY_TYPE': 'Update backlog query type',
  'UPDATE_COLUMN': 'Update column',
  'UPDATE_CONFIGURATION': 'Update configuration',
  'UPDATE_MARKER': 'Update marker',
  'UPDATE_STATUS': 'Update status',
  'UPDATE_STRUCTURE': 'Update structure',
  'UPDATED': 'Updated',
  'UPDATED_COLOR': 'Updated Color',
  'UPDATED_DESCRIPTION': 'Updated Description',
  'UPDATED_NAME': 'Updated Name',
  'UPDATED_PROJECT_ATTRIBUTE': 'Updated Project Attribute',
  'UPDATED_SCHEDULING': 'Updated Scheduling',
  'UPDATED_STATUS': 'Updated Status',
  'UPDATED_STORY_POINT': 'Updated Story Point',
  'UPDATED_YEAR_END_DATE': 'Updated Year End Date',
  'UPDATED_IN_FORM': 'Updated in Form',
  'UPDATED_IN_REPORT': 'Updated in Report',
  'URL': 'Url',
  'USE_EXISTING_TEMPLATE': 'Use Existing Template',
  'USED_DRAG_AND_DROP': 'Used Drag and Drop',
  'USER_ACCESS_LEVEL_CHANGED': 'User Access Level Changed',
  'USER_ADDED_TO_SHARING': 'User Added to Sharing',
  'USER_ADDED_TO_SHARING_EDITOR': 'User Added to Sharing - Editor',
  'USER_ADDED_TO_SHARING_VIEWER': 'User Added to Sharing - Viewer',
  'USER_OWNERSHIP_TRANSFERRED': 'User Ownership Transferred',
  'USER_REMOVED_FROM_SHARING': 'User Removed from Sharing',
  'VIEW_ALL_REPORTS': 'View All Reports',
  'VIEW_SETTINGS_CHANGED': 'View settings changed',
  'VIEWED_CAPEX_ACCOUNTS': 'Viewed Capex Accounts',
  'VIEWED_LAST_SYNC_DETAILS': 'Viewed Last Sync Details',
  'VIEWED_OPEX_ACCOUNTS': 'Viewed Opex Accounts',
  'VIEWED_PORTFOLIO_DESCRIPTION': 'Viewed Portfolio Description',
  'WELCOME_SCREEN': 'Welcome screen',
  'WRONG_DURATION': 'Wrong Duration',
  'COPIED_EXPENSE_TO_REVENUE': 'Copied Expense to Revenue',
  'DISABLE_INTERNAL_ISSUES_SUMMARIZATION': 'Disable internal issues summarization ',
  'DISABLE_USERS_CAN_MOVE_WORKLOGS_FOR_NON_LINKED_ACCOUNT': 'Disable users can move worklogs for non-linked account',
  'ENABLE_INTERNAL_ISSUES_SUMMARIZATION': 'Enable internal issues summarization ',
  'ENABLE_USERS_CAN_MOVE_WORKLOGS_FOR_NON_LINKED_ACCOUNT': 'Enable users can move worklogs for non-linked account',
  'CLICKED_APPS_BUTTON_IN_POPUP': 'Clicked Apps Button in Popup',
  'CLICKED_BOOST_PRODUCTIVITY_BUTTON': 'Clicked Boost Productivity Button',
  'USE_TEAM_SPECIFIC_CADENCE': 'Use Team specific Cadence',
  'APPLIED_ROVO_GENERATED_VIEW': 'Applied Rovo generated view',
  'ARCHIVE': 'Archive',
  'UNARCHIVE': 'Unarchive',
  'ARCHIVE_CONTACT': 'Archive Contact',
  'ARCHIVE_CUSTOMER': 'Archive Customer',
  'ARCHIVE_IDEA': 'Archive Idea',
  'ARCHIVE_PRODUCT_AREA': 'Archive Product Area',
  'ATTACHMENT_DELETED': 'Attachment Deleted',
  'COMMENTS_POSTED': 'Comments Posted',
  'CREATE_FORM': 'Create Form',
  'CREATE_IDEA': 'Create Idea',
  'CREATE_PRODUCT_AREA': 'Create Product Area',
  'DELETE_IDEA': 'Delete Idea',
  'DELETED_PRODUCT_AREA': 'Deleted Product Area',
  'EDITED_TITLE': 'Edited title',
  'FIELD_ADDED': 'Field added',
  'FIELD_REMOVED': 'Field removed',
  'GET_STARTED': 'Get Started',
  'GO_TO_IDEAS': 'Go to Ideas',
  'GO_TO_INBOX': 'Go to Inbox',
  'INTERNAL_COMMENTS_POSTED': 'Internal Comments Posted',
  'MADE_FIELD_REQUIRED': 'Made field required',
  'RESTORE': 'Restore',
  'RESTORE_CONTACT': 'Restore Contact',
  'RESTORE_CUSTOMER': 'Restore Customer',
  'RESTORE_IDEA': 'Restore Idea',
  'RESTORED_PRODUCT_AREA': 'Restored Product Area',
  'UPDATE_CUSTOMER': 'Update Customer',
  'UPDATED_CUSTOMER': 'Updated Customer',
  'UPDATED_CUSTOMERS': 'Updated Customers',
  'UPDATED_FEEDBACK': 'Updated Feedback',
  'UPDATED_PRODUCT_AREA': 'Updated Product Area',
  'UPDATED_ROADMAP_ITEMS': 'Updated Roadmap Items',
  'UPLOADED_ATTACHMENT': 'Uploaded Attachment',
  'VIEWED_FEEDBACK_LINK_CLICKED': 'Viewed Feedback Link Clicked',
  'RESTORED': 'restored',
  'CLONED_FROM_GROUP': 'Cloned from Group',
  'CONVERTED_FROM_GROUP': 'Converted from Group',
  'CHANGED_PROJECT_STATUS': 'Changed Project Status',
  'CLICKED_AUTOMATE_TIME_LOGGING': 'Clicked Automate Time Logging ',
  'CLICKED_GOOGLE': 'Clicked Google',
  'CLICKED_O365_CALENDAR': 'Clicked o365 Calendar',
  'INCLUDE_CALENDAR_EVENTS': 'Include Calendar Events',
  'RATE_CALCULATION_UPDATED': 'Rate calculation updated',
  'MANUAL_SORTING_ENABLED': 'Manual Sorting Enabled',
  'OVERWRITE_MANUAL_SORTING': 'Overwrite Manual Sorting',
  'CLICKED_RESOLVE_NOW': 'Clicked Resolve now',
  'BUILD_YOUR_OWN_ROADMAP': 'Build your own Roadmap',
  'CLICKED_CONTINUE': 'Clicked Continue',
  'START_FROM_SCRATCH': 'Start from Scratch',
  'USED_SAMPLE_ITEMS': 'Used Sample Items',
  'VIEWED_TEAMS_ROADMAP': 'Viewed Team\'s Roadmap',
  'APPROVAL_LOG': 'Approval Log',
  'DISABLED_SHOW_TEMPO_IN_THE_JIRA_ISSUE_VIEW': 'Disabled Show Tempo in the Jira Issue View',
  'ENABLED_SHOW_TEMPO_IN_THE_JIRA_ISSUE_VIEW': 'Enabled Show Tempo in the Jira Issue View',
  'SHOW_FUTURE_PERIODS': 'Show future periods',
  'SHOW_PAST_PERIODS': 'Show past periods',
  'DISMISSED': 'Dismissed',
  'JOINED_TEAMS_ROADMAP': 'Joined Teams Roadmap',
  'ONBOARDING_CHECKLIST': 'Onboarding checklist',
  'DRILL_DOWN_FROM_SEARCH': 'Drill down from search',
  'CLOSED': 'Closed',
  'SET_UP_INTEGRATIONS': 'Set up integrations',
  'CLICKED_DISCONNECT': 'clicked disconnect',
  'VIEW_CLOSED': 'view closed',
  'VIEW_OPENED': 'view opened',
  'BREAD_CRUMB': 'Bread crumb',
  'BREAD_CRUMB_FROM_SEARCH': 'Bread crumb from search',
  'CLICKED_FROM_TAKE_ACTION_PANEL': 'Clicked from Take Action panel',
  'CLICKED_FROM_SIDE_PANEL': 'Clicked from side panel',
  'CLICKED_ON_PAGE': 'Clicked on page',
  'CLICKED_ON_WORK_ITEM': 'Clicked on work item',
  'CLICKED_VIEW_DETAILS': 'Clicked view details',
  'DRILL_DOWN': 'Drill down',
  'NAVIGATION': 'Navigation',
  'OPENED': 'Opened',
  'OPENED_FROM_WORK_ITEMS': 'Opened from work items',
  'QUESTION_SUBMITTED': 'Question submitted',
  'SET_ESTIMATE': 'Set Estimate',
  'SET_PARENT': 'Set Parent',
  'SET_TEAM': 'Set Team',
  'UPDATED_FILTER': 'Updated filter',
  'UPDATED_SORTING': 'Updated sorting',
  'ADD_COLUMN_FIELD_SELECTOR': 'Add Column - Field Selector',
  'ADD_COLUMN_FORMULA': 'Add Column - Formula',
  'CONTEXT_MENU': 'Context Menu',
  'FORMULA_EDITOR': 'Formula Editor',
  'BORDERS_DISABLED': 'Borders disabled',
  'BORDERS_ENABLED': 'Borders enabled',
  'ACTIVE': 'Active',
  'ARCHIVED': 'Archived',
} as const;
export type OriginActionType = typeof OriginAction;
export type OriginActionValueType = OriginActionType[keyof OriginActionType];

export const TimelineViewType = {
  'DAYS': 'Days',
  'MONTHS': 'Months',
  'QUARTER': 'Quarter',
  'WEEKS': 'Weeks',
} as const;
export type TimelineViewTypeType = typeof TimelineViewType;
export type TimelineViewTypeValueType = TimelineViewTypeType[keyof TimelineViewTypeType];

export const LoopCreationPath = {
  'ADD_ITEMS_IN_LOOP': 'add_items_in_loop',
  'IMPORT_ITEMS': 'import_items',
} as const;
export type LoopCreationPathType = typeof LoopCreationPath;
export type LoopCreationPathValueType = LoopCreationPathType[keyof LoopCreationPathType];

export const VisualizationArtifactFormat = {
  'PDF': 'pdf',
  'PNG': 'png',
  'REALTIME_LINK': 'realtime_link',
  'SNAPSHOT_LINK': 'snapshot_link',
  'SVG': 'svg',
} as const;
export type VisualizationArtifactFormatType = typeof VisualizationArtifactFormat;
export type VisualizationArtifactFormatValueType = VisualizationArtifactFormatType[keyof VisualizationArtifactFormatType];

let sysWebBrowser: any;
let sysWebBrowserVersion: any;
let sysSegmentSourceType: any;
let sysAppVersion: any;
let sysMonetizenowProductIdSystem: any;
let sysMonetizenowAccountIdSystem: any;
let sysPagePath: any;

export function setSystemProperties(properties: {webBrowser: string;
    webBrowserVersion: string;
    segmentSourceType: SegmentSourceTypeValueType;
    appVersion: string;
    monetizenowProductIdSystem: string[];
    monetizenowAccountIdSystem: string;
    pagePath: string}) {
if (properties.webBrowser !== null && properties.webBrowser !== undefined) {
  sysWebBrowser = properties.webBrowser;
}
if (properties.webBrowserVersion !== null && properties.webBrowserVersion !== undefined) {
  sysWebBrowserVersion = properties.webBrowserVersion;
}
if (properties.segmentSourceType !== null && properties.segmentSourceType !== undefined) {
  sysSegmentSourceType = properties.segmentSourceType;
}
if (properties.appVersion !== null && properties.appVersion !== undefined) {
  sysAppVersion = properties.appVersion;
}
if (properties.monetizenowProductIdSystem !== null && properties.monetizenowProductIdSystem !== undefined) {
  sysMonetizenowProductIdSystem = properties.monetizenowProductIdSystem;
}
if (properties.monetizenowAccountIdSystem !== null && properties.monetizenowAccountIdSystem !== undefined) {
  sysMonetizenowAccountIdSystem = properties.monetizenowAccountIdSystem;
}
if (properties.pagePath !== null && properties.pagePath !== undefined) {
  sysPagePath = properties.pagePath;
}
}

let TempoSPM: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {webBrowser: string;
    webBrowserVersion: string;
    segmentSourceType: SegmentSourceTypeValueType;
    appVersion: string;
    monetizenowProductIdSystem: string[];
    monetizenowAccountIdSystem: string;
    pagePath: string},
    destinationOptions: any,
    TempoSPMDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

setSystemProperties(systemProperties);

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

TempoSPM = TempoSPMDestination;
if (__AVO_ENV__ === 'prod') {
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, "KmQbMUXlKnuk5xZqOnOnB5qJbP6VfvGn");
} else if (__AVO_ENV__ === 'dev') {
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, "9bQbgq69CasXFjqyAgtfv6xN0Palosww");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Tempo SPM. Head to destination settings in Avo to set a staging key.");
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

function assertRecIdList(recIdList: RecIdList[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("09605DknvELAOyf9fAnJa", "rec_id_list", recIdList));
if (recIdList !== null && recIdList !== undefined && recIdList.forEach) {
  recIdList.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("09605DknvELAOyf9fAnJa", "item at index " + index + " in rec_id_list", value));
});
}
return messages;
}

function assertLoopIdList(loopIdList: LoopIdList[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("1CWoCAkmR9KwS8o5i9eWd", "loop_id_list", loopIdList));
if (loopIdList !== null && loopIdList !== undefined && loopIdList.forEach) {
  loopIdList.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("1CWoCAkmR9KwS8o5i9eWd", "item at index " + index + " in loop_id_list", value));
});
}
return messages;
}

function assertAffectedItemCount(affectedItemCount: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("4ybRkawjvL8UHY7Jg5V_r", _label ? "affected_item_count" + ': ' + _label : "affected_item_count", affectedItemCount));
messages = messages.concat(AvoAssert.assertMin("4ybRkawjvL8UHY7Jg5V_r", _label ? "affected_item_count" + ": " + _label : "affected_item_count", 1, affectedItemCount));
return messages;
}

function assertItemEditedCount(itemEditedCount: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("5zT_ippbDWZkhuIA4sKp-", _label ? "item_edited_count" + ': ' + _label : "item_edited_count", itemEditedCount));
messages = messages.concat(AvoAssert.assertMin("5zT_ippbDWZkhuIA4sKp-", _label ? "item_edited_count" + ": " + _label : "item_edited_count", 0, itemEditedCount));
return messages;
}

function assertItemIdArray(itemIdArray: ItemIdArray[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("7APOxdGO9Rj946biBkD5Q", "item_id_array", itemIdArray));
if (itemIdArray !== null && itemIdArray !== undefined && itemIdArray.forEach) {
  itemIdArray.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("7APOxdGO9Rj946biBkD5Q", "item at index " + index + " in item_id_array", value));
});
}
return messages;
}

function assertTotalRecommendations(totalRecommendations: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("CYKhXO82EVuyw5G8gkrMM", _label ? "total_recommendations" + ': ' + _label : "total_recommendations", totalRecommendations));
messages = messages.concat(AvoAssert.assertMin("CYKhXO82EVuyw5G8gkrMM", _label ? "total_recommendations" + ": " + _label : "total_recommendations", 0, totalRecommendations));
return messages;
}

function assertRecDescriptionLength(recDescriptionLength: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("NnpVYm2i5J9vs0zWP9G9F", _label ? "rec_description_length" + ': ' + _label : "rec_description_length", recDescriptionLength));
messages = messages.concat(AvoAssert.assertMin("NnpVYm2i5J9vs0zWP9G9F", _label ? "rec_description_length" + ": " + _label : "rec_description_length", 0, recDescriptionLength));
return messages;
}

function assertFilterValueSelectedCount(filterValueSelectedCount: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("SMVhsjY3NruV8n7fLG3ql", _label ? "filter_value_selected_count" + ': ' + _label : "filter_value_selected_count", filterValueSelectedCount));
messages = messages.concat(AvoAssert.assertMin("SMVhsjY3NruV8n7fLG3ql", _label ? "filter_value_selected_count" + ": " + _label : "filter_value_selected_count", 1, filterValueSelectedCount));
return messages;
}

function assertRecPriorityRank(recPriorityRank: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("yOLCxKjF8bClP4s3191oz", _label ? "rec_priority_rank" + ': ' + _label : "rec_priority_rank", recPriorityRank));
messages = messages.concat(AvoAssert.assertMin("yOLCxKjF8bClP4s3191oz", _label ? "rec_priority_rank" + ": " + _label : "rec_priority_rank", 1, recPriorityRank));
return messages;
}

function assertParametersApplied(parametersApplied: ParametersApplied[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("zcsjPvmAeFGlttayjjr_X", "parameters_applied", parametersApplied));
if (parametersApplied !== null && parametersApplied !== undefined && parametersApplied.forEach) {
  parametersApplied.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("zcsjPvmAeFGlttayjjr_X", "item at index " + index + " in parameters_applied", value));
});
}
return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface IdentifiedUserTempoLoopProperties {
  userId_: string;
  subStatus: boolean;
  orgName: string;
  orgId: string;
  userId: string;
  userTimezone: string;
  userContinent: string;
  userLocale: string;
  userRole: UserRoleValueType;
  emailUser: string;
  firstLogin: string;
  lastLogin: string;
}
/**
 * Identified User: This event is sent when a user is identified.
 * variant description: This event is sent when a user is identified in Tempo Loop
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.subStatus: Status of the subscription
 * @param properties.orgName: The name of the organization a user belongs to, and is active in, during the time of identification
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.userId: The product backend User ID
 * @param properties.userTimezone: User Timezone (browser)
 * @param properties.userContinent: Name of User Continent
 * @param properties.userLocale: Instance language
 * @param properties.userRole: The role assigned to determine permission level within the product. These are not the user-defined roles managed by staff for people and teams.  For loop, users accepting an invitation can only be orchestrator or visualizer; orchestrator for those who orchestrate workflows, and visualizer for those who view insights.
 * @param properties.emailUser: email tied to a user
 * @param properties.firstLogin: date of first login
 * @param properties.lastLogin: date of last login for the user
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/D_vI8GsYA.i558eSEvs2Qso99WLFk1O}
 */
export function identifiedUserTempoLoop(properties: IdentifiedUserTempoLoopProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "-UCTfVhRU", name: "sub_status", value: properties.subStatus});
userPropertiesArray.push({id: "EjsWi6PUEsg64Z1fOuakt", name: "org_name", value: properties.orgName});
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
userPropertiesArray.push({id: "WrXB4sX-G", name: "user_id", value: properties.userId});
userPropertiesArray.push({id: "pWC73umMS", name: "user_timezone", value: properties.userTimezone});
userPropertiesArray.push({id: "u_btaafHt", name: "user_continent", value: properties.userContinent});
userPropertiesArray.push({id: "EQuG4nG1i", name: "user_locale", value: properties.userLocale});
userPropertiesArray.push({id: "SeHaN7nzr", name: "user_role", value: properties.userRole});
userPropertiesArray.push({id: "PsG9cwcrg", name: "email_user", value: properties.emailUser});
userPropertiesArray.push({id: "ZJgKVlGcP", name: "first_login", value: properties.firstLogin});
userPropertiesArray.push({id: "XL0pgckov", name: "last_login", value: properties.lastLogin});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "D_vI8GsYA.i558eSEvs2Qso99WLFk1O", "5acff95fbfb33cc8c004d6663d75b312a5df3722408f38ba591a612ae61faabb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Identified User", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("D_vI8GsYA.i558eSEvs2Qso99WLFk1O", "Identified User", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  TempoSPM.identify(properties.userId_);
  TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
} else {
  // do nothing
}
}

export interface PageViewedProperties {
  customDestinationPageName_: string;
}
/**
 * Page Viewed: Triggered when a user loads a page
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/GvLcC7uRsO/trigger/RCfGkuUiQCRPxKsBjk2NY
 * 
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/GvLcC7uRsO}
 */
export function pageViewed(properties: PageViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "GvLcC7uRsO", "d019be412f0ea6fbed5b87788cb196a9c3bb110a0537e1d6facc21a80324c9d6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("GvLcC7uRsO", "Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  if (TempoSPM.logPage) {
    TempoSPM.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface PageViewedLoopIntelligenceProperties {
  customDestinationPageName_: string;
  recIdList: RecIdList[];
  loopIdList: LoopIdList[];
  intelligenceTab: IntelligenceTabValueType;
  recAssignLens: RecAssignLensValueType | null | undefined;
}
/**
 * Page Viewed: Triggered when a user loads a pagevariant description: A page view on the Loop Intelligence page, carrying metadata on the recommendations and loops in context at the time of the page view.
 * 
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.recIdList: A list of the rec_ids in context.
 * @param properties.loopIdList: A list of the loop_ids in context.
 * @param properties.intelligenceTab: The Loop Intelligence tab in context. Either the default view, completed assignments/recommendations or assigned/uncompleted recommendations.
 * @param properties.recAssignLens: The lens in context for the assigned recommendation. Either assigned by the user or assigned to the user.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/GvLcC7uRsO.JoxBWqIr_3Cwlt4BuM7av}
 */
export function pageViewedLoopIntelligence(properties: PageViewedLoopIntelligenceProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "09605DknvELAOyf9fAnJa", name: "rec_id_list", value: properties.recIdList.map(function(value) { return {
    "rec_id": value.recId,
}
})});
eventPropertiesArray.push({id: "1CWoCAkmR9KwS8o5i9eWd", name: "loop_id_list", value: properties.loopIdList.map(function(value) { return {
    "loop_id": value.loopId,
}
})});
eventPropertiesArray.push({id: "EY1MaRX2jpRWgvTlvqJ8d", name: "intelligence_tab", value: properties.intelligenceTab});
properties.recAssignLens !== undefined && properties.recAssignLens !== null ?
  eventPropertiesArray.push({id: "_t3CQf7j9U9ryJAuFUZ_T", name: "rec_assign_lens", value: properties.recAssignLens}) :
  eventPropertiesArray.push({id: "_t3CQf7j9U9ryJAuFUZ_T", name: "rec_assign_lens", value: null});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecIdList(properties.recIdList));
  messages = messages.concat(assertLoopIdList(properties.loopIdList));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "GvLcC7uRsO.JoxBWqIr_3Cwlt4BuM7av", "96ae23309c38850b80e1c000fe8107f9ef97b1f51e7732a0e5598fae72f8569c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("GvLcC7uRsO.JoxBWqIr_3Cwlt4BuM7av", "Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Page Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  if (TempoSPM.logPage) {
    TempoSPM.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface PlanCreatedProperties {
  approvalEnabled: boolean;
  approvalRequested: boolean;
  approvalStatus: ApprovalStatusValueType;
  daysUntilPlanStarts: number;
  descriptionIncluded: boolean;
  descriptionLength: number;
  durationInDays: number;
  isForNonWorkingDays: boolean;
  isForOther: boolean;
  isForPeriod: boolean;
  isWithStartAndEndTimeEnabled: boolean;
  originAction: OriginActionValueType;
  originPage: OriginPageValueType;
  originView: OriginViewValueType;
  permissionsGranted: PermissionsGrantedValueType[];
  planType: PlanTypeValueType;
  repeatRule: RepeatRuleValueType;
  resourceType: ResourceTypeValueType;
  teamScopedPlan: boolean;
  timeSelection: TimeSelectionValueType;
  timelineViewType: TimelineViewTypeValueType;
  workSeconds: number;
  syncedWithJira: boolean;
}
/**
 * Plan Created: Triggered when a user successfully plans work to a time period
 * 
 * @param properties the properties associated with this event
 * @param properties.approvalEnabled: boolean, whether or not approval is enabled
 * @param properties.approvalRequested: boolean, whether or not the user has selected someone to review their planned time
 * @param properties.approvalStatus: the approval status of the planned time
 * @param properties.daysUntilPlanStarts: the number of days until the planned time starts
 * @param properties.descriptionIncluded: whether or not a user included a description (for time log, time plan, team, etc.)
 * @param properties.descriptionLength: the character length of the description
 * @param properties.durationInDays: the duration_in_days of the period in days (if applicable)
 * @param properties.isForNonWorkingDays: whether or not a log is tracked on non-working days
 * @param properties.isForOther: whether or not the user is logging/planning time for someone else
 * @param properties.isForPeriod: whether or not the log is for a period vs a single day
 * @param properties.isWithStartAndEndTimeEnabled: whether or not the log has the start and end time fields enabled
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.originPage: the page the user was on when they performed the action (eg. User Timesheet, JIRA Issue View)
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * @param properties.permissionsGranted: the list of permissions granted to the permission role (eg. manage plans permission)
 * @param properties.planType: property to understand the type of plan (eg. issue, project)
 * @param properties.repeatRule: the repeat rule for when the planned time will repeat over the period
 * @param properties.resourceType: type of resource in planner (eg. generic, user, team)
 * @param properties.teamScopedPlan: boolean, whether or not the user's plan time is scoped to a specific team (only available from Team Planning Page)
 * @param properties.timeSelection: the time selection for how the time is applied over the period (eg. per-day)
 * @param properties.timelineViewType: timeline that is associated with the period that is being interactive with
 * @param properties.workSeconds: the number of seconds associated with a time log (eg. work seconds, planned seconds, suggested seconds)
 * @param properties.syncedWithJira: the plan is synced with Jira issue
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/TBZqdgOK_Cq}
 */
export function planCreated(properties: PlanCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "6V1P8i7bspLk", name: "approval_enabled", value: properties.approvalEnabled});
eventPropertiesArray.push({id: "aFP-MPNIUBK9", name: "approval_requested", value: properties.approvalRequested});
eventPropertiesArray.push({id: "4gbI9lGEj6q5", name: "approval_status", value: properties.approvalStatus});
eventPropertiesArray.push({id: "DjW5j6dsG-MV", name: "days_until_plan_starts", value: properties.daysUntilPlanStarts});
eventPropertiesArray.push({id: "eC21IYwnRIYf", name: "description_included", value: properties.descriptionIncluded});
eventPropertiesArray.push({id: "7n3uQM6bo55N", name: "description_length", value: properties.descriptionLength});
eventPropertiesArray.push({id: "LNzArsrdRp6B", name: "duration_in_days", value: properties.durationInDays});
eventPropertiesArray.push({id: "qcqp6P98CoVs", name: "is_for_non_working_days", value: properties.isForNonWorkingDays});
eventPropertiesArray.push({id: "dy3NTdqWns5o", name: "is_for_other", value: properties.isForOther});
eventPropertiesArray.push({id: "M8UxAdRLQPeV", name: "is_for_period", value: properties.isForPeriod});
eventPropertiesArray.push({id: "aZiGJF2SS62H", name: "is_with_start_and_end_time_enabled", value: properties.isWithStartAndEndTimeEnabled});
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "__jqucy_Vx9b", name: "origin_page", value: properties.originPage});
eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView});
eventPropertiesArray.push({id: "1isw6cke2cx4", name: "permissions_granted", value: properties.permissionsGranted});
eventPropertiesArray.push({id: "5yTwoNOfWiXh", name: "plan_type", value: properties.planType});
eventPropertiesArray.push({id: "5ozzd8bG4UV7", name: "repeat_rule", value: properties.repeatRule});
eventPropertiesArray.push({id: "pGzwv5W10Y1O", name: "resource_type", value: properties.resourceType});
eventPropertiesArray.push({id: "3AUeirBTFDJf", name: "team_scoped_plan", value: properties.teamScopedPlan});
eventPropertiesArray.push({id: "MZavVYgy0mjm", name: "time_selection", value: properties.timeSelection});
eventPropertiesArray.push({id: "wNEFE3sY0y6H", name: "timeline_view_type", value: properties.timelineViewType});
eventPropertiesArray.push({id: "qDBbb8ljTPNw", name: "work_seconds", value: properties.workSeconds});
eventPropertiesArray.push({id: "RZE0lqJ2x7", name: "synced_with_jira", value: properties.syncedWithJira});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "TBZqdgOK_Cq", "b15ee9a0f09295686ce1217421d8b7cb1086d14fec0a081897370b00de2e8d01", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Plan Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("TBZqdgOK_Cq", "Plan Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Created", eventProperties, "TBZqdgOK_Cq", "b15ee9a0f09295686ce1217421d8b7cb1086d14fec0a081897370b00de2e8d01");
}
// destination TempoSPM
TempoSPM.logEvent("Plan Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PlanCreatedTempoSPMProperties {
  planStartDate: string[];
  planDuration: number[];
  planEndDate: string[];
  spmPlanId: string;
}
/**
 * Plan Created: Triggered when a user successfully plans work to a time periodvariant description: A user on created a new plan in Tempo SPM
 * 
 * @param properties the properties associated with this event
 * @param properties.planStartDate: The plan start date selected by a user when a plan is created.
 * @param properties.planDuration: The plan duration: plan_end_date - plan_start_date, in number of days
 * @param properties.planEndDate: The plan end date selected by a user when a plan is created
 * @param properties.spmPlanId: Plan ID in Tempo SPM app
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/TBZqdgOK_Cq.ZjfV0y3B24lt-jpXbBHQr}
 */
export function planCreatedTempoSpm(properties: PlanCreatedTempoSPMProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "1EFTVTm6WqRX-uDsBRBZS", name: "plan_start_date", value: properties.planStartDate});
eventPropertiesArray.push({id: "KCj4BZSzwwQ1X40tM845G", name: "plan_duration", value: properties.planDuration});
eventPropertiesArray.push({id: "RcdE2L2mD2qwO5SHbuTBy", name: "plan_end_date", value: properties.planEndDate});
eventPropertiesArray.push({id: "odzSbNS_f7rKxZnHomgQQ", name: "spm_plan_id", value: properties.spmPlanId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "TBZqdgOK_Cq.ZjfV0y3B24lt-jpXbBHQr", "489b8f5a78127a107187b2b049f2b965dc3224da9b64a63f2a0c766cebeb874f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Plan Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("TBZqdgOK_Cq.ZjfV0y3B24lt-jpXbBHQr", "Plan Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Created", eventProperties, "TBZqdgOK_Cq.ZjfV0y3B24lt-jpXbBHQr", "489b8f5a78127a107187b2b049f2b965dc3224da9b64a63f2a0c766cebeb874f");
}
// destination TempoSPM
TempoSPM.logEvent("Plan Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TeamImportedLoopProperties {
  numberOfTeams: number;
  integrationInstanceUrl: string;
  loopId: string;
  teamType: string;
  integrationInstanceId: string;
}
/**
 * Team Imported: Triggered when a team is importedvariant description: Fires when a user imports teams from Jira Teams or Tempo Teams into Loop.
 * 
 * @param properties the properties associated with this event
 * @param properties.numberOfTeams: the number of teams
 * @param properties.integrationInstanceUrl: URL of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira site URL (e.g. https://acme.atlassian.net). Sourced from integrations.instance_url in the item-store DB.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.teamType: The type of team synced in a sceanrio– tempo team or jira.
 * @param properties.integrationInstanceId: Identifier of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira cloud ID. Sourced from integrations.instance_id in the item-store DB.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/87Se8Dx50H.DzQzLtl3n_OsD7BL2ToVv}
 */
export function teamImportedLoop(properties: TeamImportedLoopProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "D4boOohyBnRm", name: "number_of_teams", value: properties.numberOfTeams});
eventPropertiesArray.push({id: "Zsg1cyHSo2EgAcmosKOFV", name: "integration_instance_url", value: properties.integrationInstanceUrl});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "quZgRbB-7ffBX02mxGvn0", name: "team_type", value: properties.teamType});
eventPropertiesArray.push({id: "ryBXwyg2uwUXcm6bFOSD6", name: "integration_instance_id", value: properties.integrationInstanceId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "87Se8Dx50H.DzQzLtl3n_OsD7BL2ToVv", "3b9962d2ffb0e474f729c8377a54a9d7220e6beac5f8d91c16f61dbd3e574001", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Team Imported", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("87Se8Dx50H.DzQzLtl3n_OsD7BL2ToVv", "Team Imported", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Team Imported", eventProperties, "87Se8Dx50H.DzQzLtl3n_OsD7BL2ToVv", "3b9962d2ffb0e474f729c8377a54a9d7220e6beac5f8d91c16f61dbd3e574001");
}
// destination TempoSPM
TempoSPM.logEvent("Team Imported", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * User Invite Sent: Fires when a user successfully sends organization invites from the Invite Users dialog, emitted once per invited email. (No event-specific properties.)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/cvukdjuTmI}
 */
export function userInviteSent() {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "cvukdjuTmI", "8226a3289f8601c77d449d942c449b0a1eb31b170f55582747bc2032393b04b7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("User Invite Sent", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("cvukdjuTmI", "User Invite Sent", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Invite Sent", eventProperties, "cvukdjuTmI", "8226a3289f8601c77d449d942c449b0a1eb31b170f55582747bc2032393b04b7");
}
// destination TempoSPM
TempoSPM.logEvent("User Invite Sent", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationCreatedProperties {
  organizationId: string;
  organizationName: string;
}
/**
 * Organization Created: Fires when a new organization is created successfully, from both the signup/onboarding flow and the in-app "Create organization" dialog. Sends the org's id and slug name.
 * 
 * @param properties the properties associated with this event
 * @param properties.organizationId: unique identifier of an organization(LP)
 * @param properties.organizationName: The name of the organization. The slug, and not the display name, which can change over time.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/X9sJf7FQHnKeNy0FF7-Mz}
 */
export function organizationCreated(properties: OrganizationCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "WMcrqKNyJ", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "zEADyk4Gv", name: "organization_name", value: properties.organizationName});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "X9sJf7FQHnKeNy0FF7-Mz", "4828baca929db12a9bae8e5f2d5eed62c1157389730dbb74b39a2e224cf67e83", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Organization Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("X9sJf7FQHnKeNy0FF7-Mz", "Organization Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Organization Created", eventProperties, "X9sJf7FQHnKeNy0FF7-Mz", "4828baca929db12a9bae8e5f2d5eed62c1157389730dbb74b39a2e224cf67e83");
}
// destination TempoSPM
TempoSPM.logEvent("Organization Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemSearchedProperties {
  originPage: OriginPageValueType;
  originView: OriginViewValueType;
}
/**
 * Item Searched: Fires when a user selects an item from the dashboard toolbar's item-picker search results (only when the selection came from a search query), recording originPage and originView.
 * 
 * @param properties the properties associated with this event
 * @param properties.originPage: the page the user was on when they performed the action (eg. User Timesheet, JIRA Issue View)
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/pdLpZSEIZ9Vjrx20dAOSO}
 */
export function itemSearched(properties: ItemSearchedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "__jqucy_Vx9b", name: "origin_page", value: properties.originPage});
eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "pdLpZSEIZ9Vjrx20dAOSO", "ebbb8f06f2f3e00aae9b122ee4987944110c15b099389a77c2c4e9298174d1a7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Searched", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("pdLpZSEIZ9Vjrx20dAOSO", "Item Searched", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Searched", eventProperties, "pdLpZSEIZ9Vjrx20dAOSO", "ebbb8f06f2f3e00aae9b122ee4987944110c15b099389a77c2c4e9298174d1a7");
}
// destination TempoSPM
TempoSPM.logEvent("Item Searched", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AskAIInteractedProperties {
  originAction: OriginActionValueType;
  isSuggestion: boolean;
  feedbackType: string;
  hasComment: boolean;
}
/**
 * Ask AI Interacted: Fires when a user interacts with the Ask AI ("Ask Looper") assistant — submitting a question (optionally from a suggested prompt) or rating an answer. Distinguishes the interaction via isSuggestion, feedbackType, hasComment, and originAction.
 * 
 * @param properties the properties associated with this event
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.isSuggestion: suggested : Boolean
 * @param properties.feedbackType: This is to track user feedback on AI performance using thumbs up / thumbs down.
 * @param properties.hasComment: when users add comments
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/3VZVkj5bmIc_mhuZ7TFJP}
 */
export function askAiInteracted(properties: AskAIInteractedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "qZ7ouIqCa7a3YI9FI7-JP", name: "is_suggestion", value: properties.isSuggestion});
eventPropertiesArray.push({id: "MTikcQ1fss5AiUDJMbVWK", name: "feedback_type", value: properties.feedbackType});
eventPropertiesArray.push({id: "2rDrlM_JZVQX5GDZbDHSL", name: "has_comment", value: properties.hasComment});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3VZVkj5bmIc_mhuZ7TFJP", "35623c83dd5651653c2b4725367bb029d7e37895e68dc38babd9a94976520a32", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Ask AI Interacted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3VZVkj5bmIc_mhuZ7TFJP", "Ask AI Interacted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ask AI Interacted", eventProperties, "3VZVkj5bmIc_mhuZ7TFJP", "35623c83dd5651653c2b4725367bb029d7e37895e68dc38babd9a94976520a32");
}
// destination TempoSPM
TempoSPM.logEvent("Ask AI Interacted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PlanScopeFilteredProperties {
  planDuration: number[];
  planStartDate: string[];
  planEndDate: string[];
  planAccessSetting: PlanAccessSettingValueType;
  loopId: string;
  filterField: string;
  filterValueSelectedCount: number;
}
/**
 * Plan Scope Filtered: The user selected or applied a filter to narrow down results. Tracks one filter field at a time.
 * 
 * @param properties the properties associated with this event
 * @param properties.planDuration: The plan duration: plan_end_date - plan_start_date, in number of days
 * @param properties.planStartDate: The plan start date selected by a user when a plan is created.
 * @param properties.planEndDate: The plan end date selected by a user when a plan is created
 * @param properties.planAccessSetting: The level of access determined by the plan owner.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.filterField: The name of the field selected by the user to filter on (e.g.For plan scope filtering, Team, Status, and quick filters)
 * @param properties.filterValueSelectedCount: The number of values selected when a user filters on a field. For example, if a user filters on Status values 'Completed' and 'In Review', the value will be 2.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/QLkW0oH6ten8EqwLyLOYp}
 */
export function planScopeFiltered(properties: PlanScopeFilteredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "KCj4BZSzwwQ1X40tM845G", name: "plan_duration", value: properties.planDuration});
eventPropertiesArray.push({id: "1EFTVTm6WqRX-uDsBRBZS", name: "plan_start_date", value: properties.planStartDate});
eventPropertiesArray.push({id: "RcdE2L2mD2qwO5SHbuTBy", name: "plan_end_date", value: properties.planEndDate});
eventPropertiesArray.push({id: "tagUbrk0tMLPghlbjzZlf", name: "plan_access_setting", value: properties.planAccessSetting});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "FqWO68EluTEuHeNSEwtAo", name: "filter_field", value: properties.filterField});
eventPropertiesArray.push({id: "SMVhsjY3NruV8n7fLG3ql", name: "filter_value_selected_count", value: properties.filterValueSelectedCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertFilterValueSelectedCount(properties.filterValueSelectedCount));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QLkW0oH6ten8EqwLyLOYp", "43737aaea4431a05da40026f8b12925785a96c76d2e9af439afe435478d329da", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Plan Scope Filtered", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QLkW0oH6ten8EqwLyLOYp", "Plan Scope Filtered", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Plan Scope Filtered': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Scope Filtered", eventProperties, "QLkW0oH6ten8EqwLyLOYp", "43737aaea4431a05da40026f8b12925785a96c76d2e9af439afe435478d329da");
}
// destination TempoSPM
TempoSPM.logEvent("Plan Scope Filtered", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PlanAccessUpdatedProperties {
  spmPlanId: string;
  planAccessSettingUpdated: boolean;
  planAccessUserAdded: boolean;
}
/**
 * Plan Access Updated: A user updates the access of a plan by changing the general level of access, or adding a specific user. Only saved changes are tracked.
 * 
 * @param properties the properties associated with this event
 * @param properties.spmPlanId: Plan ID in Tempo SPM app
 * @param properties.planAccessSettingUpdated: Access setting (Open/Private) is changed
 * @param properties.planAccessUserAdded: A user is added to the list of users on a plan.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/hMJ8U01FDqMpj9GnSbSv6}
 */
export function planAccessUpdated(properties: PlanAccessUpdatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "odzSbNS_f7rKxZnHomgQQ", name: "spm_plan_id", value: properties.spmPlanId});
eventPropertiesArray.push({id: "28n5znFNtZsZsUwNgnFQv", name: "plan_access_setting_updated", value: properties.planAccessSettingUpdated});
eventPropertiesArray.push({id: "sPM9vYjDGml9h9zCBwD0X", name: "plan_access_user_added", value: properties.planAccessUserAdded});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "hMJ8U01FDqMpj9GnSbSv6", "ab1a9177141bdf342870cd380bd046fdfd127d8ad3bcb6c544727d29d2e5af1f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Plan Access Updated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("hMJ8U01FDqMpj9GnSbSv6", "Plan Access Updated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Access Updated", eventProperties, "hMJ8U01FDqMpj9GnSbSv6", "ab1a9177141bdf342870cd380bd046fdfd127d8ad3bcb6c544727d29d2e5af1f");
}
// destination TempoSPM
TempoSPM.logEvent("Plan Access Updated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PortfolioItemsEditedProperties {
  itemEditedCount: number;
  itemEffortEdited: boolean;
  itemTeamEdited: boolean;
  loopId: string;
  itemStatusEdited: boolean;
  itemTypeEdited: boolean;
  itemNameEdited: boolean;
  itemDateFieldEdited: boolean;
  isBulkEdit: boolean;
  itemPanel: boolean;
  itemIdArray: ItemIdArray[];
}
/**
 * Portfolio Items Edited: Fires when a user edits one or more items in a portfolio view (inline cell, bulk-edit bar, or item side panel); guarded to track only user-driven edits, not syncs. Records which field types changed, isBulkEdit, and itemEditedCount.
 * 
 * @param properties the properties associated with this event
 * @param properties.itemEditedCount: The number of items edited by the user based on plan changes.
 * @param properties.itemEffortEdited: Boolean to determine if a change was made to the effort assigned to the item .
 * @param properties.itemTeamEdited: Boolean to determine if a change was made to the team assigned to the item .
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemStatusEdited: Boolean to determine if a change was made to the status of the item .
 * @param properties.itemTypeEdited: Boolean to determine if a change was made to the org item type for a specific item.
 * @param properties.itemNameEdited: Boolean to determine if a change was made to the name of the item .
 * @param properties.itemDateFieldEdited: Boolean to determine if a change was made to the planned start or planned end date on the item in the portfolio.
 * @param properties.isBulkEdit: Whether the edit was a bulk edit (multiple scenario items via the bulk-edit bar) vs a single-item edit.
 * @param properties.itemPanel: A boolean to determine if the edit occurred on the panel or table view of the scenario/planner. When referenced in item creation actions, this relates to the modal or table view.
 * Item Panel or Modal: True
 * Table View: False
 * @param properties.itemIdArray: An array of item_id values related to the event action.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/i9qL3qcDznU25JNKtnDYA}
 */
export function portfolioItemsEdited(properties: PortfolioItemsEditedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5zT_ippbDWZkhuIA4sKp-", name: "item_edited_count", value: properties.itemEditedCount});
eventPropertiesArray.push({id: "zU1h_DLLTqmwRIGDieSCS", name: "item_effort_edited", value: properties.itemEffortEdited});
eventPropertiesArray.push({id: "pixY_p3V2_c4pRpp1wMSA", name: "item_team_edited", value: properties.itemTeamEdited});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "9jREG7GGX0Fk89G550Wd4", name: "item_status_edited", value: properties.itemStatusEdited});
eventPropertiesArray.push({id: "Rdqzk6Zz7zHivQOCQDd1h", name: "item_type_edited", value: properties.itemTypeEdited});
eventPropertiesArray.push({id: "ntDuWH2PG0sD_hCzLwUHy", name: "item_name_edited", value: properties.itemNameEdited});
eventPropertiesArray.push({id: "VmTEdEnNujPQQWNtxB-6T", name: "item_date_field_edited", value: properties.itemDateFieldEdited});
eventPropertiesArray.push({id: "BWZWP1eD1aZ6HXLAYDwRF", name: "is_bulk_edit", value: properties.isBulkEdit});
eventPropertiesArray.push({id: "xrJm6W27q9PVWWX6a92zJ", name: "item_panel", value: properties.itemPanel});
eventPropertiesArray.push({id: "7APOxdGO9Rj946biBkD5Q", name: "item_id_array", value: properties.itemIdArray.map(function(value) { return {
    "item_id": value.itemId,
}
})});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertItemEditedCount(properties.itemEditedCount));
  messages = messages.concat(assertItemIdArray(properties.itemIdArray));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "i9qL3qcDznU25JNKtnDYA", "ae100b2326da644a8f98f609ec1a893fc60311c39fbb68f253cbf3cb3c8ecc20", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Portfolio Items Edited", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("i9qL3qcDznU25JNKtnDYA", "Portfolio Items Edited", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Portfolio Items Edited': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Items Edited", eventProperties, "i9qL3qcDznU25JNKtnDYA", "ae100b2326da644a8f98f609ec1a893fc60311c39fbb68f253cbf3cb3c8ecc20");
}
// destination TempoSPM
TempoSPM.logEvent("Portfolio Items Edited", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ScenarioParametersAdjustedProperties {
  scenarioId: number;
  instructionType: InstructionTypeValueType | null | undefined;
  instructionValue: InstructionValueValueType | null | undefined;
  instructionDial: InstructionDialValueType;
  loopId: string;
}
/**
 * Scenario Parameters Adjusted: The user adjusts a plan/scenario via radar chart or parameter refinement. Fires when a user sets or changes a planning instruction (a scenario constraint dial) that guides the AI.
 * 
 * @param properties the properties associated with this event
 * @param properties.scenarioId: Scenario ID for the scenario a user is interacting with.
 * @param properties.instructionType: The type of adjustment made by the user. If possible, use the enum under scenario constraints scale, so this value is not hardcoded. e.g. Priority Flexibility, Estimation Confidence, etc
 * @param properties.instructionValue: The level of priority for the selected radar parameter (Low, Med, High)
 * @param properties.instructionDial: Whether the slider or radar chart was used to adjust the scenario.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/ll_F2ynxB05m9vs30ZHu5}
 */
export function scenarioParametersAdjusted(properties: ScenarioParametersAdjustedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "DAYwdNGqA9J7LAIlIhcSo", name: "scenario_id", value: properties.scenarioId});
properties.instructionType !== undefined && properties.instructionType !== null ?
  eventPropertiesArray.push({id: "i-2qgTQNi1dC2s368NvpE", name: "instruction_type", value: properties.instructionType}) :
  eventPropertiesArray.push({id: "i-2qgTQNi1dC2s368NvpE", name: "instruction_type", value: null});
properties.instructionValue !== undefined && properties.instructionValue !== null ?
  eventPropertiesArray.push({id: "nShz76_Fk-ePVVNwjAEx0", name: "instruction_value", value: properties.instructionValue}) :
  eventPropertiesArray.push({id: "nShz76_Fk-ePVVNwjAEx0", name: "instruction_value", value: null});
eventPropertiesArray.push({id: "NtZBhCsXD7L6PMGFjVQIh", name: "instruction_dial", value: properties.instructionDial});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ll_F2ynxB05m9vs30ZHu5", "5c340d426767b38fee9b419323dd5bcd350f698df13f3938a3d3ac3661f3f9d6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Scenario Parameters Adjusted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ll_F2ynxB05m9vs30ZHu5", "Scenario Parameters Adjusted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scenario Parameters Adjusted", eventProperties, "ll_F2ynxB05m9vs30ZHu5", "5c340d426767b38fee9b419323dd5bcd350f698df13f3938a3d3ac3661f3f9d6");
}
// destination TempoSPM
TempoSPM.logEvent("Scenario Parameters Adjusted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PortfolioLoopCreatedProperties {
  loopId: string;
  loopCreationPath: LoopCreationPathValueType;
}
/**
 * Portfolio Loop Created: Fires when a user acts on the portfolio empty state to populate a new Loop, via either "Import items" or "Add items in Loop" (loopCreationPath).
 * 
 * @param properties the properties associated with this event
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.loopCreationPath: Describes how an item got into Loop:
 * - manual — the item was created directly by a person with access to the org.
 * - integration — the item was synced in from a connected external system (today that means Jira), via the integration flow.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/VtZGgMS-0dG_WDQ2_ATEo}
 */
export function portfolioLoopCreated(properties: PortfolioLoopCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "xfueLg9vhEMjM3ULFhzO1", name: "loop_creation_path", value: properties.loopCreationPath});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "VtZGgMS-0dG_WDQ2_ATEo", "6a2d4cb5d1c32d5cce1044537175eef7be70165ccb254c3aab8900e0c3efa0eb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Portfolio Loop Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("VtZGgMS-0dG_WDQ2_ATEo", "Portfolio Loop Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Loop Created", eventProperties, "VtZGgMS-0dG_WDQ2_ATEo", "6a2d4cb5d1c32d5cce1044537175eef7be70165ccb254c3aab8900e0c3efa0eb");
}
// destination TempoSPM
TempoSPM.logEvent("Portfolio Loop Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * User Invite Accepted: Fires when a user successfully accepts an organization invite, via both the manual invites list and the auto-accept invite-token flow. (No event-specific properties.)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/uhg_fi3zuNcHE1fV-Jok9}
 */
export function userInviteAccepted() {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "uhg_fi3zuNcHE1fV-Jok9", "fe1d1886b72924d912744ad9bb5e3b30ca5e0088f9af071391956b5179df03ee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("User Invite Accepted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("uhg_fi3zuNcHE1fV-Jok9", "User Invite Accepted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Invite Accepted", eventProperties, "uhg_fi3zuNcHE1fV-Jok9", "fe1d1886b72924d912744ad9bb5e3b30ca5e0088f9af071391956b5179df03ee");
}
// destination TempoSPM
TempoSPM.logEvent("User Invite Accepted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface IntegrationCreatedProperties {
  integrationId: string;
  integrationSource: string;
  integrationInstanceUrl: string;
  integrationInstanceId: string;
  integrationProjectId: string;
  loopId: string;
}
/**
 * Integration Created: Fires once when a user completes the Jira work-integration setup and submission succeeds (the "integration added" moment, before the first sync completes). Captures integrationId, integrationSource, instance URL/ID, and integrationProjectId.
 * 
 * @param properties the properties associated with this event
 * @param properties.integrationId: Globally unique ID of the integration instance. Sourced from integrations.id (BIGSERIAL) in the item-store DB. Stored as string. Bridges all events that belong to the same integration (e.g. Work Integration Created → Work Integration Sync Completed).
 * @param properties.integrationSource: The name of the integration provider being set up (e.g. Jira). For Loop work integrations, the value MUST mirror the SourceSystemType enum from integrations.source_system_type in the item-store DB (current enum values: JIRA; extensible to Linear, Azure DevOps, etc.).
 * @param properties.integrationInstanceUrl: URL of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira site URL (e.g. https://acme.atlassian.net). Sourced from integrations.instance_url in the item-store DB.
 * @param properties.integrationInstanceId: Identifier of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira cloud ID. Sourced from integrations.instance_id in the item-store DB.
 * @param properties.integrationProjectId: Identifier of the project within the external system that the integration is scoped to. Provider-agnostic; for Jira this is the Jira project_id. Sourced from integrations.project_id in the item-store DB.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/_H5pduU9IVJzpWQpSpUSA}
 */
export function integrationCreated(properties: IntegrationCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "wW7fx4YVT3hCrEGrN3Sn_", name: "integration_id", value: properties.integrationId});
eventPropertiesArray.push({id: "PrUyJjrKb", name: "integration_source", value: properties.integrationSource});
eventPropertiesArray.push({id: "Zsg1cyHSo2EgAcmosKOFV", name: "integration_instance_url", value: properties.integrationInstanceUrl});
eventPropertiesArray.push({id: "ryBXwyg2uwUXcm6bFOSD6", name: "integration_instance_id", value: properties.integrationInstanceId});
eventPropertiesArray.push({id: "dP187fRzZIOhF6YZLv6K4", name: "integration_project_id", value: properties.integrationProjectId});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "_H5pduU9IVJzpWQpSpUSA", "b5a0241ee99ee68cfa25f3305091138c1d0f96b8a66154daf9c6a9a3ed9f72c9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Integration Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("_H5pduU9IVJzpWQpSpUSA", "Integration Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Integration Created", eventProperties, "_H5pduU9IVJzpWQpSpUSA", "b5a0241ee99ee68cfa25f3305091138c1d0f96b8a66154daf9c6a9a3ed9f72c9");
}
// destination TempoSPM
TempoSPM.logEvent("Integration Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface InstanceCreatedProperties {
  integrationInstanceUrl: string;
  integrationInstanceId: string;
  loopId: string | null | undefined;
}
/**
 * Instance Created: Fires when a user successfully connects an external Jira instance through the Create Instance Wizard. Records integrationInstanceUrl and integrationInstanceId; loopId may be null since connected instances are shared across loops.
 * 
 * @param properties the properties associated with this event
 * @param properties.integrationInstanceUrl: URL of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira site URL (e.g. https://acme.atlassian.net). Sourced from integrations.instance_url in the item-store DB.
 * @param properties.integrationInstanceId: Identifier of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira cloud ID. Sourced from integrations.instance_id in the item-store DB.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/UChHasR8JYcRDCdnGaOBR}
 */
export function instanceCreated(properties: InstanceCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Zsg1cyHSo2EgAcmosKOFV", name: "integration_instance_url", value: properties.integrationInstanceUrl});
eventPropertiesArray.push({id: "ryBXwyg2uwUXcm6bFOSD6", name: "integration_instance_id", value: properties.integrationInstanceId});
properties.loopId !== undefined && properties.loopId !== null ?
  eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId}) :
  eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: null});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "UChHasR8JYcRDCdnGaOBR", "7ed075f496f75d4eec6db4d79063ebc7fa2524f48978a141262a8fe12e92df04", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Instance Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("UChHasR8JYcRDCdnGaOBR", "Instance Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Instance Created", eventProperties, "UChHasR8JYcRDCdnGaOBR", "7ed075f496f75d4eec6db4d79063ebc7fa2524f48978a141262a8fe12e92df04");
}
// destination TempoSPM
TempoSPM.logEvent("Instance Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PortfolioViewedProperties {
  loopId: string;
  viewId: string;
  viewItemCount: number;
}
/**
 * Portfolio Viewed: Fires once per loaded portfolio view (deduplicated per loop+view, after data finishes loading), capturing viewId and viewItemCount.
 * 
 * @param properties the properties associated with this event
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.viewId: ID of the view created
 * @param properties.viewItemCount: The number of items present in a portfolio view at the time it is rendered.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/L9d1HiQ799ERqcSowumGd}
 */
export function portfolioViewed(properties: PortfolioViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "lAP51aoAo", name: "view_id", value: properties.viewId});
eventPropertiesArray.push({id: "NGkZwIEwF5VzzKnvFFr3G", name: "view_item_count", value: properties.viewItemCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "L9d1HiQ799ERqcSowumGd", "2bf1135539704d66a3b117072d5d3901ef156fd19575c7ffb5992fcf95201bcb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Portfolio Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("L9d1HiQ799ERqcSowumGd", "Portfolio Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Viewed", eventProperties, "L9d1HiQ799ERqcSowumGd", "2bf1135539704d66a3b117072d5d3901ef156fd19575c7ffb5992fcf95201bcb");
}
// destination TempoSPM
TempoSPM.logEvent("Portfolio Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ScenarioCreatedProperties {
  scenarioId: number;
  loopId: string;
}
/**
 * Scenario Created: Fires when a new scenario is successfully created, on success of the create-scenario mutation. Records the new scenarioId and loopId.
 * 
 * @param properties the properties associated with this event
 * @param properties.scenarioId: Scenario ID for the scenario a user is interacting with.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/qJMgobDIGZLTFjHt7VmBP}
 */
export function scenarioCreated(properties: ScenarioCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "DAYwdNGqA9J7LAIlIhcSo", name: "scenario_id", value: properties.scenarioId});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qJMgobDIGZLTFjHt7VmBP", "38f09015e95634ab3813e89c847aa44b129e028201ca5a18d9a635288885b59b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Scenario Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qJMgobDIGZLTFjHt7VmBP", "Scenario Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scenario Created", eventProperties, "qJMgobDIGZLTFjHt7VmBP", "38f09015e95634ab3813e89c847aa44b129e028201ca5a18d9a635288885b59b");
}
// destination TempoSPM
TempoSPM.logEvent("Scenario Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ScenarioActivatedProperties {
  scenarioId: number;
  loopId: string;
}
/**
 * Scenario Activated: Fires when a user activates/publishes a scenario, on success of the activate-scenario mutation from the Activate Scenario dialog. Records scenarioId and loopId.
 * 
 * @param properties the properties associated with this event
 * @param properties.scenarioId: Scenario ID for the scenario a user is interacting with.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/69D23w5SivumyVBnJWCfR}
 */
export function scenarioActivated(properties: ScenarioActivatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "DAYwdNGqA9J7LAIlIhcSo", name: "scenario_id", value: properties.scenarioId});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "69D23w5SivumyVBnJWCfR", "e59de991c0d2ad9011fb20b867618f8ee08b72fd7d21a50c30fc8c0ab801cf8f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Scenario Activated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("69D23w5SivumyVBnJWCfR", "Scenario Activated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scenario Activated", eventProperties, "69D23w5SivumyVBnJWCfR", "e59de991c0d2ad9011fb20b867618f8ee08b72fd7d21a50c30fc8c0ab801cf8f");
}
// destination TempoSPM
TempoSPM.logEvent("Scenario Activated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface VisualizationPublishedProperties {
  visualizationId: string;
  visualizationArtifactFormat: VisualizationArtifactFormatValueType;
  visualizationPasswordProtected: boolean;
  visualizationArtifactType: VisualizationArtifactTypeValueType;
}
/**
 * Visualization Published: Fires when a user creates a new shareable published visualization (public link or exported PNG/PDF/SVG), recording artifact format/type and whether it's password-protected. Updates to an already-published visualization emit "Visualization Updated" instead.
 * 
 * @param properties the properties associated with this event
 * @param properties.visualizationId: The source visualization being published
 * @param properties.visualizationArtifactFormat: Describes the format of the visualization exported by the user.
 * @param properties.visualizationPasswordProtected: A flag to show whether the published artifact is password protected or not.
 * @param properties.visualizationArtifactType: Describes the format of the visualization exported by the user.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/wDmih-F76KVR0E6Xb4rQL}
 */
export function visualizationPublished(properties: VisualizationPublishedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "ZNYfGgemW1RPHoKhlLU8C", name: "visualization_id", value: properties.visualizationId});
eventPropertiesArray.push({id: "zcBJQtwEoBQhIOezs2cm-", name: "visualization_artifact_format", value: properties.visualizationArtifactFormat});
eventPropertiesArray.push({id: "l0xcYRhNcb9vJ0BllwevI", name: "visualization_password_protected", value: properties.visualizationPasswordProtected});
eventPropertiesArray.push({id: "MCMuQFYw-a1n3eTwz77nZ", name: "visualization_artifact_type", value: properties.visualizationArtifactType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "wDmih-F76KVR0E6Xb4rQL", "a7be99ed18dbe3791d730e8acbf6111e51e2b5f668d53347cdfe3eb3f3891994", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Visualization Published", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("wDmih-F76KVR0E6Xb4rQL", "Visualization Published", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visualization Published", eventProperties, "wDmih-F76KVR0E6Xb4rQL", "a7be99ed18dbe3791d730e8acbf6111e51e2b5f668d53347cdfe3eb3f3891994");
}
// destination TempoSPM
TempoSPM.logEvent("Visualization Published", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ScenarioItemsEditedProperties {
  scenarioId: number;
  isBulkEdit: boolean;
  itemsEditedCount: number;
  itemFieldNames: ItemFieldNamesValueType[];
  loopId: string;
  itemPanel: boolean;
}
/**
 * Scenario Items Edited: Fires when a user edits scenario items in the planner (single edit, bulk edit, or item panel), only when a tracked field actually changed (team, estimation, target start/finish date). Records itemFieldNames, isBulkEdit, and itemsEditedCount.
 * 
 * @param properties the properties associated with this event
 * @param properties.scenarioId: Scenario ID for the scenario a user is interacting with.
 * @param properties.isBulkEdit: Whether the edit was a bulk edit (multiple scenario items via the bulk-edit bar) vs a single-item edit.
 * @param properties.itemsEditedCount: Number of scenario items changed by this edit (1 for a single edit; changedCount for bulk). Scenario-scoped; distinct from the plan-level item_edited_count.
 * @param properties.itemFieldNames: Which scenario item field was edited.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemPanel: A boolean to determine if the edit occurred on the panel or table view of the scenario/planner. When referenced in item creation actions, this relates to the modal or table view.
 * Item Panel or Modal: True
 * Table View: False
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/u2WU4-TctARgUQ-gCkNeM}
 */
export function scenarioItemsEdited(properties: ScenarioItemsEditedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "DAYwdNGqA9J7LAIlIhcSo", name: "scenario_id", value: properties.scenarioId});
eventPropertiesArray.push({id: "BWZWP1eD1aZ6HXLAYDwRF", name: "is_bulk_edit", value: properties.isBulkEdit});
eventPropertiesArray.push({id: "Tvbh-IA_vXhyq7iw81SFm", name: "items_edited_count", value: properties.itemsEditedCount});
eventPropertiesArray.push({id: "2qSpvub-h51Ax-ESPZ_Ug", name: "item_field_names", value: properties.itemFieldNames});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "xrJm6W27q9PVWWX6a92zJ", name: "item_panel", value: properties.itemPanel});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "u2WU4-TctARgUQ-gCkNeM", "480f87e387e6149e2ac0a9fddf481af09b29a79532ca46466b631a2c18ce24e3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Scenario Items Edited", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("u2WU4-TctARgUQ-gCkNeM", "Scenario Items Edited", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scenario Items Edited", eventProperties, "u2WU4-TctARgUQ-gCkNeM", "480f87e387e6149e2ac0a9fddf481af09b29a79532ca46466b631a2c18ce24e3");
}
// destination TempoSPM
TempoSPM.logEvent("Scenario Items Edited", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ScenarioParametersAppliedProperties {
  scenarioId: number;
  loopId: string;
  parametersApplied: ParametersApplied[];
}
/**
 * Scenario Parameters Applied: Fires when a user clicks "Apply" after adjusting scenario constraint dials (priority flexibility, capacity utilization, estimation buffer) and the update succeeds; reports only the dials whose value actually changed (parametersApplied).
 * 
 * @param properties the properties associated with this event
 * @param properties.scenarioId: Scenario ID for the scenario a user is interacting with.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.parametersApplied: A list of objects carrying the type of instruction set from the available parameters, and the corresponding values.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/51SyxdJLIrsxcWu_zmJG3}
 */
export function scenarioParametersApplied(properties: ScenarioParametersAppliedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "DAYwdNGqA9J7LAIlIhcSo", name: "scenario_id", value: properties.scenarioId});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "zcsjPvmAeFGlttayjjr_X", name: "parameters_applied", value: properties.parametersApplied.map(function(value) { return {
    "instruction_type": value.instructionType,
    "instruction_value": value.instructionValue,
}
})});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertParametersApplied(properties.parametersApplied));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "51SyxdJLIrsxcWu_zmJG3", "b34dfa3913c1dc9df6dc2d606b2baaf09f70c8b4928078976cf9e94c824bf1fc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Scenario Parameters Applied", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("51SyxdJLIrsxcWu_zmJG3", "Scenario Parameters Applied", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Scenario Parameters Applied': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scenario Parameters Applied", eventProperties, "51SyxdJLIrsxcWu_zmJG3", "b34dfa3913c1dc9df6dc2d606b2baaf09f70c8b4928078976cf9e94c824bf1fc");
}
// destination TempoSPM
TempoSPM.logEvent("Scenario Parameters Applied", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationCategoryFilteredProperties {
  userId_: string;
  orgId: string;
  loopId: string;
  categoryLens: CategoryLensValueType;
  totalRecommendations: number;
  loopCount: number;
  intelligenceReadingView: IntelligenceReadingViewValueType;
}
/**
 * Recommendation Category Filtered: Fires when a user filters recommendations by category in the Intelligence tab. If all loops are in context at the time a category is filtered, loop_id = 'all'.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.totalRecommendations: Captures the number of recommendations fetched as it relates to the event in context.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.intelligenceReadingView: The view in context when a user engages with Loop Intelligence. Practitioner is Intelligence's 'classic' reading, and Leadership is the newer 'agentic' Loop Intelligence reading.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/h6yPR9lFeaSLLrVBSQ5XU}
 */
export function recommendationCategoryFiltered(properties: RecommendationCategoryFilteredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "CYKhXO82EVuyw5G8gkrMM", name: "total_recommendations", value: properties.totalRecommendations});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "5wSRLcaeliR1VRWaMNru3", name: "intelligence_reading_view", value: properties.intelligenceReadingView});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertTotalRecommendations(properties.totalRecommendations));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "h6yPR9lFeaSLLrVBSQ5XU", "bddb45668f6c6a9055581348b8a531190e2f0c7fa6fcc7e2a9487c3acc7f29ad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Category Filtered", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("h6yPR9lFeaSLLrVBSQ5XU", "Recommendation Category Filtered", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Category Filtered': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Category Filtered", eventProperties, "h6yPR9lFeaSLLrVBSQ5XU", "bddb45668f6c6a9055581348b8a531190e2f0c7fa6fcc7e2a9487c3acc7f29ad");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Recommendation Category Filtered", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface InsightViewModeToggledProperties {
  userId_: string;
  viewMode: ViewModeValueType;
  orgId: string;
  loopId: string;
}
/**
 * Insight View Mode Toggled: User toggles the insights Grid/Compact view.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.viewMode: Insights card layout after the toggle. Derived from isCompact.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/77uz1Z1iHRNVjXbYXBE7X}
 */
export function insightViewModeToggled(properties: InsightViewModeToggledProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "tbV3nHPU8xjM8swUvskUT", name: "view_mode", value: properties.viewMode});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "77uz1Z1iHRNVjXbYXBE7X", "669aee093f9998765ac372f12f90d9bd642b1dff7fa69ac6594dd7dbb8c37d00", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Insight View Mode Toggled", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("77uz1Z1iHRNVjXbYXBE7X", "Insight View Mode Toggled", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Insight View Mode Toggled", eventProperties, "77uz1Z1iHRNVjXbYXBE7X", "669aee093f9998765ac372f12f90d9bd642b1dff7fa69ac6594dd7dbb8c37d00");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Insight View Mode Toggled", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface InsightGroupingChangedProperties {
  userId_: string;
  groupingDimension: GroupingDimensionValueType;
  orgId: string;
  loopId: string;
}
/**
 * Insight Grouping Changed: User selects a different insights grouping dimension.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.groupingDimension: Selected insights grouping dimension.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/iKAG75g1P3yzhrg_PrZEp}
 */
export function insightGroupingChanged(properties: InsightGroupingChangedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "pXvjKKQwadcEmRulSvDx_", name: "grouping_dimension", value: properties.groupingDimension});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "iKAG75g1P3yzhrg_PrZEp", "88ff6b535b9adddbeab12851f02838bb7e0d6a6077c3166ab8e657097ca69ed5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Insight Grouping Changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("iKAG75g1P3yzhrg_PrZEp", "Insight Grouping Changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Insight Grouping Changed", eventProperties, "iKAG75g1P3yzhrg_PrZEp", "88ff6b535b9adddbeab12851f02838bb7e0d6a6077c3166ab8e657097ca69ed5");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Insight Grouping Changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface WorkItemLinkClickedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  userId_: string;
  orgId: string;
  itemId: string;
  recDescriptionLength: number;
}
/**
 * Work Item Link Clicked: Fires when a user opens the linked work item (Jira issue) from a recommendation on the Loop Intelligence tab, under affected items. Can fire more than once per recommendation (each open fires). Originally fired from the external link in the Affected Work Items table on the health-insight detail page.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.itemId: The affected work item referenced by a recommendation. This is an internal numeric item ID, and is not the Jira issue key, but it maps 1:1.
 * @param properties.recDescriptionLength: The length of the description shown to a user on a recommendation.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/WA-J54wUJUbOrt-EcF1nw}
 */
export function workItemLinkClicked(properties: WorkItemLinkClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "b1l_P66-U", name: "item_id", value: properties.itemId});
eventPropertiesArray.push({id: "NnpVYm2i5J9vs0zWP9G9F", name: "rec_description_length", value: properties.recDescriptionLength});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  messages = messages.concat(assertRecDescriptionLength(properties.recDescriptionLength));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WA-J54wUJUbOrt-EcF1nw", "7d2bcd279b618d8da4c17abf1240f45591062a4fa389297d9160a3f3f663e866", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Work Item Link Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WA-J54wUJUbOrt-EcF1nw", "Work Item Link Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Work Item Link Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Work Item Link Clicked", eventProperties, "WA-J54wUJUbOrt-EcF1nw", "7d2bcd279b618d8da4c17abf1240f45591062a4fa389297d9160a3f3f663e866");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Work Item Link Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemPanelTabSwitchedProperties {
  userId_: string;
  itemPanelTab: string;
  orgId: string;
  loopId: string;
  itemId: string;
  orgItemType: string;
  orgItemHierarchy: number;
}
/**
 * Item Panel Tab Switched: User switches a tab in the insight affected-item side panel.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.itemPanelTab: One of three tabs present to the user on a work item in Loop (customFields, system, planScheduling)
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemId: The affected work item referenced by a recommendation. This is an internal numeric item ID, and is not the Jira issue key, but it maps 1:1.
 * @param properties.orgItemType: The org item type for the item in context. Item types are defined by the organization.
 * @param properties.orgItemHierarchy: The number representing the org-level hierarchy related to an item in Loop.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/bmxexfMe5lS2gj0fCOJtg}
 */
export function itemPanelTabSwitched(properties: ItemPanelTabSwitchedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RiFCy8HDdbk2ccbjM6FTA", name: "item_panel_tab", value: properties.itemPanelTab});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "b1l_P66-U", name: "item_id", value: properties.itemId});
eventPropertiesArray.push({id: "1sBCmIdYTg4_4cNnI7GDO", name: "org_item_type", value: properties.orgItemType});
eventPropertiesArray.push({id: "eTz3tbDxj5TMneP9eYnBK", name: "org_item_hierarchy", value: properties.orgItemHierarchy});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "bmxexfMe5lS2gj0fCOJtg", "11d438ba2cdd58bc640aadd008e3226250fff50510b5a654aa65a2ed0e2e0784", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Panel Tab Switched", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("bmxexfMe5lS2gj0fCOJtg", "Item Panel Tab Switched", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Panel Tab Switched", eventProperties, "bmxexfMe5lS2gj0fCOJtg", "11d438ba2cdd58bc640aadd008e3226250fff50510b5a654aa65a2ed0e2e0784");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Item Panel Tab Switched", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemPanelExpandedProperties {
  userId_: string;
  isExpanded: boolean;
  orgId: string;
  loopId: string;
  itemId: string;
  orgItemType: string;
  orgItemHierarchy: number;
}
/**
 * Item Panel Expanded: User expands or collapses the insight affected-item side panel.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.isExpanded: Whether the item side panel is expanded (true) or collapsed (false).
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemId: The affected work item referenced by a recommendation. This is an internal numeric item ID, and is not the Jira issue key, but it maps 1:1.
 * @param properties.orgItemType: The org item type for the item in context. Item types are defined by the organization.
 * @param properties.orgItemHierarchy: The number representing the org-level hierarchy related to an item in Loop.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/0H8Y-7EJQ3Lz2PXSfPHmY}
 */
export function itemPanelExpanded(properties: ItemPanelExpandedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "NfQDfqRyYvSpCVyK30tx-", name: "is_expanded", value: properties.isExpanded});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "b1l_P66-U", name: "item_id", value: properties.itemId});
eventPropertiesArray.push({id: "1sBCmIdYTg4_4cNnI7GDO", name: "org_item_type", value: properties.orgItemType});
eventPropertiesArray.push({id: "eTz3tbDxj5TMneP9eYnBK", name: "org_item_hierarchy", value: properties.orgItemHierarchy});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0H8Y-7EJQ3Lz2PXSfPHmY", "ea74510cd7fde00f43624aee6fb930a7efc3fad728ab5865e950f10dfd6504b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Panel Expanded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0H8Y-7EJQ3Lz2PXSfPHmY", "Item Panel Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Panel Expanded", eventProperties, "0H8Y-7EJQ3Lz2PXSfPHmY", "ea74510cd7fde00f43624aee6fb930a7efc3fad728ab5865e950f10dfd6504b4");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Item Panel Expanded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemFieldUpdatedProperties {
  userId_: string;
  fieldKind: FieldKindValueType;
  itemFieldName: string;
  orgId: string;
  loopId: string;
  itemId: string;
  orgItemType: string;
  orgItemHierarchy: number;
}
/**
 * Item Field Updated: User edits a standard or custom field in the insight affected-item panel. This does not cover changes to items from the scenario table view.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.fieldKind: Whether the edited item field is a standard field or a custom field.
 * @param properties.itemFieldName: Key/title of the item field edited in the insight panel (standard field key or custom field id).
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemId: The affected work item referenced by a recommendation. This is an internal numeric item ID, and is not the Jira issue key, but it maps 1:1.
 * @param properties.orgItemType: The org item type for the item in context. Item types are defined by the organization.
 * @param properties.orgItemHierarchy: The number representing the org-level hierarchy related to an item in Loop.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/xUhOfSL75LDrdfOTdQnu2}
 */
export function itemFieldUpdated(properties: ItemFieldUpdatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "XI3hxGDGMKE8UNWBVgUSw", name: "field_kind", value: properties.fieldKind});
eventPropertiesArray.push({id: "3Pa0k1g5xwox8KxLEk_8f", name: "item_field_name", value: properties.itemFieldName});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "b1l_P66-U", name: "item_id", value: properties.itemId});
eventPropertiesArray.push({id: "1sBCmIdYTg4_4cNnI7GDO", name: "org_item_type", value: properties.orgItemType});
eventPropertiesArray.push({id: "eTz3tbDxj5TMneP9eYnBK", name: "org_item_hierarchy", value: properties.orgItemHierarchy});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "xUhOfSL75LDrdfOTdQnu2", "47df09db24e568622a6248435d8f77ae5dd5bb9b4c9628ebf15d32e54dfbafca", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Field Updated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("xUhOfSL75LDrdfOTdQnu2", "Item Field Updated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Field Updated", eventProperties, "xUhOfSL75LDrdfOTdQnu2", "47df09db24e568622a6248435d8f77ae5dd5bb9b4c9628ebf15d32e54dfbafca");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Item Field Updated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationIdentifiedProperties {
  associateUserWithOrganization: string;
  updateGroupPropertiesForOrganization: string;
  orgGroupId: string;
  orgGroupName: string;
  orgRecId: string;
}
/**
 * Organization Identified: Associates a user with their Organization on identify/app-load. Does not fire an actual event.
 * 
 * @param properties the properties associated with this event
 * @param properties.associateUserWithOrganization (id of the Organization group to associate current user with): no description
 * @param properties.updateGroupPropertiesForOrganization (id of the Organization group to update group properties for): no description
 * @param properties.orgGroupId (Organization group property): Unique identifier of the Organization. Set as a property on the 'Organization' group and matches the group key used to associate users and events with their org. Populated from the authenticated user's org context on identify/app-load; same value as organization_id on Organization Created.
 * @param properties.orgGroupName (Organization group property): The Organization's name — specifically the org slug (a stable identifier), not the mutable display name. Set as a property on the 'Organization' group. Populated from the authenticated user's org context on identify/app-load; same value as organization_name on Organization Created.
 * @param properties.orgRecId (Organization group property): Identifier for the consolidated set of recommendations shown to the org — the whole feed as one unit, not any single recommendation within it. There is one such set per org at a time, so this scopes the interaction to that set as a whole.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/00bywGo21SVP48nnDET_7}
 */
export function organizationIdentified(properties: OrganizationIdentifiedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "00bywGo21SVP48nnDET_7", "adcbdd9625ee05cc6844b7e03713f2d83177ebb7693f539fcfca4ebfbeb3698f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Organization Identified", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("00bywGo21SVP48nnDET_7", "Organization Identified", messages, eventPropertiesArray, userPropertiesArray, [
  {id: "fd158b94-cdf1-4130-9e11-05cfde17b62euser", groupName: "Organization", groupId: "fd158b94-cdf1-4130-9e11-05cfde17b62e", name: "Associates user with group", value: properties.associateUserWithOrganization},
  {id: "_DDoU7pkHEUcuSJ9Zqhz5", groupName: "Organization", groupId: properties.updateGroupPropertiesForOrganization, name: "org_group_id", value: properties.orgGroupId},
  {id: "LOua4Pd9uyeYJv3MiDitM", groupName: "Organization", groupId: properties.updateGroupPropertiesForOrganization, name: "org_group_name", value: properties.orgGroupName},
  {id: "a1IRTkORKk53FXdf-ghBZ", groupName: "Organization", groupId: properties.updateGroupPropertiesForOrganization, name: "org_rec_id", value: properties.orgRecId},
  ]);
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  TempoSPM.addCurrentUserToGroup("Organization", properties.associateUserWithOrganization, {
    "org_group_id": properties.orgGroupId,
    "org_group_name": properties.orgGroupName,
    "org_rec_id": properties.orgRecId,
    });
TempoSPM.setGroupProperties("Organization", properties.updateGroupPropertiesForOrganization, {
  "org_group_id": properties.orgGroupId,
  "org_group_name": properties.orgGroupName,
  "org_rec_id": properties.orgRecId,
  });
} else {
  // do nothing
}
}

export interface VisualizationUpdatedProperties {
  visualizationId: string;
  visualizationArtifactFormat: VisualizationArtifactFormatValueType;
  visualizationPasswordProtected: boolean;
  visualizationPublishAction: VisualizationPublishActionValueType;
  visualizationArtifactType: VisualizationArtifactTypeValueType;
}
/**
 * Visualization Updated: Fires when a user updates or deletes settings for a visualization link.
 * 
 * @param properties the properties associated with this event
 * @param properties.visualizationId: The source visualization being published
 * @param properties.visualizationArtifactFormat: Describes the format of the visualization exported by the user.
 * @param properties.visualizationPasswordProtected: A flag to show whether the published artifact is password protected or not.
 * @param properties.visualizationPublishAction: To denote the publish action performed in the update, related to the visualization format. For files (pdf, etc), this value is always create, for links the value can be create/update/delete.
 * @param properties.visualizationArtifactType: Describes the format of the visualization exported by the user.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/JU0VpvMclET4GdbsqAbkT}
 */
export function visualizationUpdated(properties: VisualizationUpdatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "ZNYfGgemW1RPHoKhlLU8C", name: "visualization_id", value: properties.visualizationId});
eventPropertiesArray.push({id: "zcBJQtwEoBQhIOezs2cm-", name: "visualization_artifact_format", value: properties.visualizationArtifactFormat});
eventPropertiesArray.push({id: "l0xcYRhNcb9vJ0BllwevI", name: "visualization_password_protected", value: properties.visualizationPasswordProtected});
eventPropertiesArray.push({id: "G62Pc_H96Nj9I4ZMTs6LD", name: "visualization_publish_action", value: properties.visualizationPublishAction});
eventPropertiesArray.push({id: "MCMuQFYw-a1n3eTwz77nZ", name: "visualization_artifact_type", value: properties.visualizationArtifactType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "JU0VpvMclET4GdbsqAbkT", "8803d4e0ff4e5b3f34129569ca01e4f159a9633eb1bd5abe326ff856b5810609", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Visualization Updated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("JU0VpvMclET4GdbsqAbkT", "Visualization Updated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visualization Updated", eventProperties, "JU0VpvMclET4GdbsqAbkT", "8803d4e0ff4e5b3f34129569ca01e4f159a9633eb1bd5abe326ff856b5810609");
}
// destination TempoSPM
TempoSPM.logEvent("Visualization Updated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemSyncInitiatedProperties {
  loopId: string;
  integrationId: string;
  integrationSource: string;
  integrationInstanceId: string;
  syncDirection: SyncDirectionValueType;
}
/**
 * Item Sync Initiated: Fires when a user triggers a work-integration sync (e.g. "Sync to Jira") and the sync begins. Records loopId, the integration instance and its integrationSource, and syncDirection (push or pull).
 * 
 * @param properties the properties associated with this event
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.integrationId: Globally unique ID of the integration instance. Sourced from integrations.id (BIGSERIAL) in the item-store DB. Stored as string. Bridges all events that belong to the same integration (e.g. Work Integration Created → Work Integration Sync Completed).
 * @param properties.integrationSource: The name of the integration provider being set up (e.g. Jira). For Loop work integrations, the value MUST mirror the SourceSystemType enum from integrations.source_system_type in the item-store DB (current enum values: JIRA; extensible to Linear, Azure DevOps, etc.).
 * @param properties.integrationInstanceId: Identifier of the external system instance the integration is connected to. Provider-agnostic; for Jira this is the Jira cloud ID. Sourced from integrations.instance_id in the item-store DB.
 * @param properties.syncDirection: Attribute to track whether an integration sync initiated is for a push to the integration source, or a pull.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/8pvaHdtNDhZ0EvIJ1hoET}
 */
export function itemSyncInitiated(properties: ItemSyncInitiatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "wW7fx4YVT3hCrEGrN3Sn_", name: "integration_id", value: properties.integrationId});
eventPropertiesArray.push({id: "PrUyJjrKb", name: "integration_source", value: properties.integrationSource});
eventPropertiesArray.push({id: "ryBXwyg2uwUXcm6bFOSD6", name: "integration_instance_id", value: properties.integrationInstanceId});
eventPropertiesArray.push({id: "gvAM5Lmlpl-BEJsK5iJqe", name: "sync_direction", value: properties.syncDirection});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "8pvaHdtNDhZ0EvIJ1hoET", "67170dc5d6c53941280c3829b47fb99c5bea3e21e4ee7df2b9e6fca3147d74ed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Sync Initiated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("8pvaHdtNDhZ0EvIJ1hoET", "Item Sync Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Sync Initiated", eventProperties, "8pvaHdtNDhZ0EvIJ1hoET", "67170dc5d6c53941280c3829b47fb99c5bea3e21e4ee7df2b9e6fca3147d74ed");
}
// destination TempoSPM
TempoSPM.logEvent("Item Sync Initiated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PortfolioItemCreatedProperties {
  loopId: string;
  itemId: string;
  orgItemType: string;
  orgItemHierarchy: number;
  descriptionIncluded: boolean;
  itemPanel: boolean;
}
/**
 * Portfolio Item Created: Fires when a user manually creates a work item in a Loop portfolio, via the create-item wizard (itemPanel: true) or inline in the portfolio table (itemPanel: false). Captures itemId, resolved org type/hierarchy, and descriptionIncluded; excludes items added by portfolio syncs.
 * 
 * @param properties the properties associated with this event
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.itemId: The affected work item referenced by a recommendation. This is an internal numeric item ID, and is not the Jira issue key, but it maps 1:1.
 * @param properties.orgItemType: The org item type for the item in context. Item types are defined by the organization.
 * @param properties.orgItemHierarchy: The number representing the org-level hierarchy related to an item in Loop.
 * @param properties.descriptionIncluded: whether or not a user included a description (for time log, time plan, team, etc.)
 * @param properties.itemPanel: A boolean to determine if the edit occurred on the panel or table view of the scenario/planner. When referenced in item creation actions, this relates to the modal or table view.
 * Item Panel or Modal: True
 * Table View: False
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/7_uxeSNt3CwWK3ZP-ZoAH}
 */
export function portfolioItemCreated(properties: PortfolioItemCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "b1l_P66-U", name: "item_id", value: properties.itemId});
eventPropertiesArray.push({id: "1sBCmIdYTg4_4cNnI7GDO", name: "org_item_type", value: properties.orgItemType});
eventPropertiesArray.push({id: "eTz3tbDxj5TMneP9eYnBK", name: "org_item_hierarchy", value: properties.orgItemHierarchy});
eventPropertiesArray.push({id: "eC21IYwnRIYf", name: "description_included", value: properties.descriptionIncluded});
eventPropertiesArray.push({id: "xrJm6W27q9PVWWX6a92zJ", name: "item_panel", value: properties.itemPanel});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "7_uxeSNt3CwWK3ZP-ZoAH", "96a958b969be518d4b535b1f0f018200d2a5e2cc16fc391b1d1cb98a55e3efc6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Portfolio Item Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("7_uxeSNt3CwWK3ZP-ZoAH", "Portfolio Item Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Item Created", eventProperties, "7_uxeSNt3CwWK3ZP-ZoAH", "96a958b969be518d4b535b1f0f018200d2a5e2cc16fc391b1d1cb98a55e3efc6");
}
// destination TempoSPM
TempoSPM.logEvent("Portfolio Item Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface DashboardCreatedProperties {
  dashboardId: string;
  loopId: string;
  dashboardLayout: string;
  dashboardLayoutSlotCount: number;
}
/**
 * Dashboard Created: Fires when a user creates a dashboard in Loop.
 * 
 * @param properties the properties associated with this event
 * @param properties.dashboardId: the id of the JIRA dashboard
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.dashboardLayout: The layout selected during dashboard creation in loop. The layout carries several options as an enum in the codebase, and these are the strings added on this property (e.g. single, two-column, etc).
 * @param properties.dashboardLayoutSlotCount: The number of slots associated with the layout selected during dashboard creation in Loop.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/aXGPRy3up2iuFGCBDSWA5}
 */
export function dashboardCreated(properties: DashboardCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "LgqLfnW47", name: "dashboard_id", value: properties.dashboardId});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "gJp3QIZrky9xf5RAnyBdB", name: "dashboard_layout", value: properties.dashboardLayout});
eventPropertiesArray.push({id: "b76aiBAf-GBP_dJGJPLsR", name: "dashboard_layout_slot_count", value: properties.dashboardLayoutSlotCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "aXGPRy3up2iuFGCBDSWA5", "21b73ce57442ef59aa8785a69c158f829306be0f7a6daf0aefc3cbcb5e92c3fe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Dashboard Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("aXGPRy3up2iuFGCBDSWA5", "Dashboard Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Created", eventProperties, "aXGPRy3up2iuFGCBDSWA5", "21b73ce57442ef59aa8785a69c158f829306be0f7a6daf0aefc3cbcb5e92c3fe");
}
// destination TempoSPM
TempoSPM.logEvent("Dashboard Created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface WorkTitleSetProperties {
  userTitle: string;
}
/**
 * Work Title Set: Fires when a user submits the work title modal in the Loop Intelligence tab, capturing the title they entered.
 * 
 * @param properties the properties associated with this event
 * @param properties.userTitle: the title/role of the user (eg. Business Analyst, CEO, Developer, etc.)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/gaqOFxZImcXcE6DKYAooY}
 */
export function workTitleSet(properties: WorkTitleSetProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "uiJhf2DcB", name: "user_title", value: properties.userTitle});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "gaqOFxZImcXcE6DKYAooY", "52897f7d470a289a2801a57f84a0338ca39edfcd83dba84a96fea94ae20ef158", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Work Title Set", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("gaqOFxZImcXcE6DKYAooY", "Work Title Set", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Work Title Set", eventProperties, "gaqOFxZImcXcE6DKYAooY", "52897f7d470a289a2801a57f84a0338ca39edfcd83dba84a96fea94ae20ef158");
}
// destination TempoSPM
TempoSPM.logEvent("Work Title Set", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationLoopFilteredProperties {
  userId_: string;
  orgId: string;
  loopId: string;
  categoryLens: CategoryLensValueType;
  totalRecommendations: number;
  loopCount: number;
  intelligenceReadingView: IntelligenceReadingViewValueType;
}
/**
 * Recommendation Loop Filtered: Fires when a user filters to specific loops for Recommendations in the Intelligence tab. When all loops are selected, loop_id is "all".
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.totalRecommendations: Captures the number of recommendations fetched as it relates to the event in context.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.intelligenceReadingView: The view in context when a user engages with Loop Intelligence. Practitioner is Intelligence's 'classic' reading, and Leadership is the newer 'agentic' Loop Intelligence reading.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/yc6zhxRJh3YSaf2gQ4gwT}
 */
export function recommendationLoopFiltered(properties: RecommendationLoopFilteredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "CYKhXO82EVuyw5G8gkrMM", name: "total_recommendations", value: properties.totalRecommendations});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "5wSRLcaeliR1VRWaMNru3", name: "intelligence_reading_view", value: properties.intelligenceReadingView});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertTotalRecommendations(properties.totalRecommendations));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yc6zhxRJh3YSaf2gQ4gwT", "87b21a1ce6e594f9d57238c619e573915b8543a93e49b86ba5c3f118c6477d1c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Loop Filtered", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yc6zhxRJh3YSaf2gQ4gwT", "Recommendation Loop Filtered", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Loop Filtered': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Loop Filtered", eventProperties, "yc6zhxRJh3YSaf2gQ4gwT", "87b21a1ce6e594f9d57238c619e573915b8543a93e49b86ba5c3f118c6477d1c");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Recommendation Loop Filtered", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationRowExpandedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType | null | undefined;
  recTimeHorizon: RecTimeHorizonValueType | null | undefined;
  recCatalogAction: string | null | undefined;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  intelligenceReadingView: IntelligenceReadingViewValueType;
  intelligenceTab: IntelligenceTabValueType;
  recAssignLens: RecAssignLensValueType | null | undefined;
}
/**
 * Recommendation Row Expanded: Fires when a specific recommendation row is expanded.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.intelligenceReadingView: The view in context when a user engages with Loop Intelligence. Practitioner is Intelligence's 'classic' reading, and Leadership is the newer 'agentic' Loop Intelligence reading.
 * @param properties.intelligenceTab: The Loop Intelligence tab in context. Either the default view, completed assignments/recommendations or assigned/uncompleted recommendations.
 * @param properties.recAssignLens: The lens in context for the assigned recommendation. Either assigned by the user or assigned to the user.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/vGmZvSVw7-LJ1nTQ90cSJ}
 */
export function recommendationRowExpanded(properties: RecommendationRowExpandedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
properties.recPriority !== undefined && properties.recPriority !== null ?
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority}) :
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: null});
properties.recTimeHorizon !== undefined && properties.recTimeHorizon !== null ?
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon}) :
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: null});
properties.recCatalogAction !== undefined && properties.recCatalogAction !== null ?
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction}) :
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: null});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "5wSRLcaeliR1VRWaMNru3", name: "intelligence_reading_view", value: properties.intelligenceReadingView});
eventPropertiesArray.push({id: "EY1MaRX2jpRWgvTlvqJ8d", name: "intelligence_tab", value: properties.intelligenceTab});
properties.recAssignLens !== undefined && properties.recAssignLens !== null ?
  eventPropertiesArray.push({id: "_t3CQf7j9U9ryJAuFUZ_T", name: "rec_assign_lens", value: properties.recAssignLens}) :
  eventPropertiesArray.push({id: "_t3CQf7j9U9ryJAuFUZ_T", name: "rec_assign_lens", value: null});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vGmZvSVw7-LJ1nTQ90cSJ", "32b302f089be813682e8bd2cccce1eada322389211019952394269c351dcdd51", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Row Expanded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vGmZvSVw7-LJ1nTQ90cSJ", "Recommendation Row Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Row Expanded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Row Expanded", eventProperties, "vGmZvSVw7-LJ1nTQ90cSJ", "32b302f089be813682e8bd2cccce1eada322389211019952394269c351dcdd51");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Row Expanded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationAffectedItemsExpandedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  affectedItemCount: number;
}
/**
 * Recommendation Affected Items Expanded: Fires when the affected items panel is expanded for the recommendation in context. 
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.affectedItemCount: The number of affected items related to the object in context in Loop.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/S0ocQNrHx2Nj3enhRiC2d}
 */
export function recommendationAffectedItemsExpanded(properties: RecommendationAffectedItemsExpandedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "4ybRkawjvL8UHY7Jg5V_r", name: "affected_item_count", value: properties.affectedItemCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  messages = messages.concat(assertAffectedItemCount(properties.affectedItemCount));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "S0ocQNrHx2Nj3enhRiC2d", "0cbd53f72b9d5e99544548253737324f1a411cb1400dd4a86ef3c9c011f624ec", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Affected Items Expanded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("S0ocQNrHx2Nj3enhRiC2d", "Recommendation Affected Items Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Affected Items Expanded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Affected Items Expanded", eventProperties, "S0ocQNrHx2Nj3enhRiC2d", "0cbd53f72b9d5e99544548253737324f1a411cb1400dd4a86ef3c9c011f624ec");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Affected Items Expanded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationFeedbackClickedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  userId_: string;
  orgId: string;
  rating: RatingValueType;
}
/**
 * Recommendation Feedback Clicked: Fires when a user clicks on one of the feedback options on a recommendation– either thumbs up or thumbs down.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.rating: User feedback on the AI summary — positive (thumbs up) or negative (thumbs down).
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/MN2S0pnJ718y1SFxHpZ6B}
 */
export function recommendationFeedbackClicked(properties: RecommendationFeedbackClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "F1dmGdfsnisbI_HHbMOYp", name: "rating", value: properties.rating});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "MN2S0pnJ718y1SFxHpZ6B", "b5bbe921bc775bb051f959b8802095e9e8402d3b630759ba5ca10d429e240077", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Feedback Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("MN2S0pnJ718y1SFxHpZ6B", "Recommendation Feedback Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Feedback Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Feedback Clicked", eventProperties, "MN2S0pnJ718y1SFxHpZ6B", "b5bbe921bc775bb051f959b8802095e9e8402d3b630759ba5ca10d429e240077");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Recommendation Feedback Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationFeedbackFormDismissedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  userId_: string;
  orgId: string;
}
/**
 * Recommendation Feedback Form Dismissed: Fires when a user dismisses the feedback form after sharing negative feedback on a recommendation.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/rKENT7WZXUPKtslvJHOZE}
 */
export function recommendationFeedbackFormDismissed(properties: RecommendationFeedbackFormDismissedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "rKENT7WZXUPKtslvJHOZE", "2b107b16123826af4cfff9952626942797bd9d1284dc16384b612e60aaf89fc3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Feedback Form Dismissed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("rKENT7WZXUPKtslvJHOZE", "Recommendation Feedback Form Dismissed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Feedback Form Dismissed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Feedback Form Dismissed", eventProperties, "rKENT7WZXUPKtslvJHOZE", "2b107b16123826af4cfff9952626942797bd9d1284dc16384b612e60aaf89fc3");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Recommendation Feedback Form Dismissed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationFeedbackFormSubmittedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  userId_: string;
  orgId: string;
  feedbackReason: string;
}
/**
 * Recommendation Feedback Form Submitted: Fires when a user successfully submits a feedback form when sharing a reason for negative feedback on a recommendation.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.orgId: The unique identifier for an organization in Loop
 * @param properties.feedbackReason: The reason for negative feedback shared by the user, as it relates to the recommendation in context.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/qDtOfGJvZHuF355G0NXqX}
 */
export function recommendationFeedbackFormSubmitted(properties: RecommendationFeedbackFormSubmittedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "hv9-cQewSmaxmquidHmYI", name: "feedback_reason", value: properties.feedbackReason});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "tkvPl-3sLYh6Ywmq2avuD", name: "org_id", value: properties.orgId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qDtOfGJvZHuF355G0NXqX", "2f368eeb2c39cddc57c446c9750bd518ba0c67951f198dcf9268487dc18239a0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Feedback Form Submitted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qDtOfGJvZHuF355G0NXqX", "Recommendation Feedback Form Submitted", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Feedback Form Submitted': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Feedback Form Submitted", eventProperties, "qDtOfGJvZHuF355G0NXqX", "2f368eeb2c39cddc57c446c9750bd518ba0c67951f198dcf9268487dc18239a0");
}
// destination TempoSPM
TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
TempoSPM.logEvent("Recommendation Feedback Form Submitted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationActionsExpandedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType;
  recTimeHorizon: RecTimeHorizonValueType;
  recCatalogAction: string;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
}
/**
 * Recommendation Actions Expanded: Fires when a specific action in a recommendation row is expanded. The first recommendation is shown by default, so this only applies to other recommended actions on the same bullet / row.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/AcHnby6i-ehV7o4Ok_TBh}
 */
export function recommendationActionsExpanded(properties: RecommendationActionsExpandedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority});
eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon});
eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "AcHnby6i-ehV7o4Ok_TBh", "1859f4452177c194d556f607b600ed38c1235a4f9a4ccfbdb1247cb1552c287a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Actions Expanded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("AcHnby6i-ehV7o4Ok_TBh", "Recommendation Actions Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Actions Expanded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Actions Expanded", eventProperties, "AcHnby6i-ehV7o4Ok_TBh", "1859f4452177c194d556f607b600ed38c1235a4f9a4ccfbdb1247cb1552c287a");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Actions Expanded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationFootnoteExpandedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType | null | undefined;
  recTimeHorizon: RecTimeHorizonValueType | null | undefined;
  recCatalogAction: string | null | undefined;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  recFootnoteType: RecFootnoteTypeValueType;
}
/**
 * Recommendation Footnote Expanded: Fires when a specific agentic footnote is expanded.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.recFootnoteType: The type of agentic footnote on the recommendation in context that the user interacted with. Either alternatives or sources, shown as 'What could make this wrong' and 'Where the data came from', respectively.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/BfvDTHVtf-XyKB0zd5x5I}
 */
export function recommendationFootnoteExpanded(properties: RecommendationFootnoteExpandedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
properties.recPriority !== undefined && properties.recPriority !== null ?
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority}) :
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: null});
properties.recTimeHorizon !== undefined && properties.recTimeHorizon !== null ?
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon}) :
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: null});
properties.recCatalogAction !== undefined && properties.recCatalogAction !== null ?
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction}) :
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: null});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "gwmsyRFkTKOy_sK-wPZwd", name: "rec_footnote_type", value: properties.recFootnoteType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "BfvDTHVtf-XyKB0zd5x5I", "359c8a8630890c601dc2c86e44dfcd01c2739dc8634e7549a205f05288892cc8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Footnote Expanded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("BfvDTHVtf-XyKB0zd5x5I", "Recommendation Footnote Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Footnote Expanded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Footnote Expanded", eventProperties, "BfvDTHVtf-XyKB0zd5x5I", "359c8a8630890c601dc2c86e44dfcd01c2739dc8634e7549a205f05288892cc8");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Footnote Expanded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ReadingViewToggledProperties {
  intelligenceReadingView: IntelligenceReadingViewValueType;
}
/**
 * Reading View Toggled: When the user toggles between the default (classic) and agentic views of recommendations.
 * 
 * @param properties the properties associated with this event
 * @param properties.intelligenceReadingView: The view in context when a user engages with Loop Intelligence. Practitioner is Intelligence's 'classic' reading, and Leadership is the newer 'agentic' Loop Intelligence reading.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/At9-_sLrWcgxtqBZIjjSe}
 */
export function readingViewToggled(properties: ReadingViewToggledProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wSRLcaeliR1VRWaMNru3", name: "intelligence_reading_view", value: properties.intelligenceReadingView});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "At9-_sLrWcgxtqBZIjjSe", "437a73e538c92d3bd91742de564528368eac54006cf148809ddc5ad51647c157", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Reading View Toggled", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("At9-_sLrWcgxtqBZIjjSe", "Reading View Toggled", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reading View Toggled", eventProperties, "At9-_sLrWcgxtqBZIjjSe", "437a73e538c92d3bd91742de564528368eac54006cf148809ddc5ad51647c157");
}
// destination TempoSPM
TempoSPM.logEvent("Reading View Toggled", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationActionClickedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType | null | undefined;
  recTimeHorizon: RecTimeHorizonValueType | null | undefined;
  recCatalogAction: string | null | undefined;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  recActionType: RecActionTypeValueType;
}
/**
 * Recommendation Action Clicked: Fires when a specific action in a recommendation row is clicked to assign a recommendation, mark it as completed or dismissed. 
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.recActionType: The action taken on the recommendation: assign, complete, or dismiss.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/NKf44N-r3183XbHXclPEW}
 */
export function recommendationActionClicked(properties: RecommendationActionClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
properties.recPriority !== undefined && properties.recPriority !== null ?
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority}) :
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: null});
properties.recTimeHorizon !== undefined && properties.recTimeHorizon !== null ?
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon}) :
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: null});
properties.recCatalogAction !== undefined && properties.recCatalogAction !== null ?
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction}) :
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: null});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "Tqatt3_zH7mJuDDuB9XeW", name: "rec_action_type", value: properties.recActionType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NKf44N-r3183XbHXclPEW", "21c7f00b2e73489e7af72bc336ba429630479959c4dfffb7730f7fd631a40197", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Action Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NKf44N-r3183XbHXclPEW", "Recommendation Action Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Action Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Action Clicked", eventProperties, "NKf44N-r3183XbHXclPEW", "21c7f00b2e73489e7af72bc336ba429630479959c4dfffb7730f7fd631a40197");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Action Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RecommendationActionRevertedProperties {
  categoryLens: CategoryLensValueType;
  loopId: string;
  recId: string;
  recTitleLength: number;
  recPriority: RecPriorityValueType | null | undefined;
  recTimeHorizon: RecTimeHorizonValueType | null | undefined;
  recCatalogAction: string | null | undefined;
  recScope: RecScopeValueType[];
  recPriorityRank: number;
  recEvidenceSource: string[];
  loopCount: number;
  recRevertType: RecRevertTypeValueType;
}
/**
 * Recommendation Action Reverted: Fires when a specific action from a recommendation is reverted after being marked completed or dismissed. A user can revert an action via "undo" or "redo" after dismissing a recommendation, or marking it as completed.
 * 
 * @param properties the properties associated with this event
 * @param properties.categoryLens: Which health-insight lens the recommendation list is filtered to: risk, efficiency, focus, growth, or all'. For agentic recommendations, this is the Finding Group: risk, opportunity, ontrack, dataReadiness.
 * @param properties.loopId: The unique ID that identifies a specific planning workspace (a 'Loop'). Used to keep all of an organization's strategy and execution data grouped together.
 * @param properties.recId: Unique identifier of the individual recommendation line (bullet) shown to the user. Feedback and other per-line interactions are keyed on this, and has the general format rcb_xxx. In the SIR data model, this is defined as bullet_id.
 * @param properties.recTitleLength: The length of the title of the recommendation, by character count.
 * @param properties.recPriority: The priority assigned to the recommendation.
 * @param properties.recTimeHorizon: The time horizon assigned to the recommendation in context.
 * @param properties.recCatalogAction: The catalog action related to the recommendation in context. The main actions are cutting scope, reassign, raise in retro, but will likely expand over time.
 * @param properties.recScope: The field describing the scope(s) related to a recommendation. Typically, either team, org,  loop or a combination of these. In the data model, this is the scope kind for a signal.
 * @param properties.recPriorityRank: The number showing the position of the recommendation in a list served to a user in the Loop Intelligence tab.
 * @param properties.recEvidenceSource: The source(s) related to the recommendation shown to the user. jira, git, hris or a combination of these values.
 * @param properties.loopCount: The number of loops in context when the event fires.
 * @param properties.recRevertType: The action taken to reverse a previously completed or dismissed recommendation: undo or redo.
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/XAevbhjo85paEkYAzKVZJ/events/pqUoWVupQO6w3tKQZnvxX}
 */
export function recommendationActionReverted(properties: RecommendationActionRevertedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CWli6kpYIdVTQGpfBSoAt", name: "category_lens", value: properties.categoryLens});
eventPropertiesArray.push({id: "lSK3HT3I5hyWNSo7bJCEg", name: "loop_id", value: properties.loopId});
eventPropertiesArray.push({id: "s_4X2RHC8Nf9HLbz3wCWu", name: "rec_id", value: properties.recId});
eventPropertiesArray.push({id: "FN7yIYkXoGfMLEF3QAqsQ", name: "rec_title_length", value: properties.recTitleLength});
properties.recPriority !== undefined && properties.recPriority !== null ?
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: properties.recPriority}) :
  eventPropertiesArray.push({id: "c1HRdavl3E0lEBkT0upKk", name: "rec_priority", value: null});
properties.recTimeHorizon !== undefined && properties.recTimeHorizon !== null ?
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: properties.recTimeHorizon}) :
  eventPropertiesArray.push({id: "ltT0OhqV9WM2qmh-CTSO7", name: "rec_time_horizon", value: null});
properties.recCatalogAction !== undefined && properties.recCatalogAction !== null ?
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: properties.recCatalogAction}) :
  eventPropertiesArray.push({id: "wGjuuEM60meLkH1Jm19RF", name: "rec_catalog_action", value: null});
eventPropertiesArray.push({id: "gny9eb50-mWYLpKuXtg5d", name: "rec_scope", value: properties.recScope});
eventPropertiesArray.push({id: "yOLCxKjF8bClP4s3191oz", name: "rec_priority_rank", value: properties.recPriorityRank});
eventPropertiesArray.push({id: "_k3OWcW8GfTf-yT9KwcX8", name: "rec_evidence_source", value: properties.recEvidenceSource});
eventPropertiesArray.push({id: "SStLPO4fBVL2u07CscKMH", name: "loop_count", value: properties.loopCount});
eventPropertiesArray.push({id: "WOLEBMhV_j1XwkX3t520z", name: "rec_revert_type", value: properties.recRevertType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
eventPropertiesArray.push({id: "hYE-qlIvvsKzKyhmBmy6P", name: "monetizenow_product_id_system", value: sysMonetizenowProductIdSystem});
eventPropertiesArray.push({id: "4OhAysI4UDNnJ-dap9SqB", name: "monetizenow_account_id_system", value: sysMonetizenowAccountIdSystem});
eventPropertiesArray.push({id: "6MFE9aoTQZT9nuBmE7iWK", name: "page_path", value: sysPagePath});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertRecPriorityRank(properties.recPriorityRank));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "pqUoWVupQO6w3tKQZnvxX", "f3f499b4e14936691787e70b19f2eefd457729b851f02c86c74d0d119de85dfb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Recommendation Action Reverted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("pqUoWVupQO6w3tKQZnvxX", "Recommendation Action Reverted", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Recommendation Action Reverted': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Action Reverted", eventProperties, "pqUoWVupQO6w3tKQZnvxX", "f3f499b4e14936691787e70b19f2eefd457729b851f02c86c74d0d119de85dfb");
}
// destination TempoSPM
TempoSPM.logEvent("Recommendation Action Reverted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  SegmentSourceType,
  PermissionsGranted,
  ItemFieldNames,
  ApprovalStatus,
  RepeatRule,
  IntelligenceReadingView,
  PlanType,
  CategoryLens,
  IntelligenceTab,
  Rating,
  VisualizationPublishAction,
  VisualizationArtifactType,
  TimeSelection,
  OriginView,
  InstructionDial,
  UserRole,
  RecActionType,
  RecRevertType,
  FieldKind,
  OriginPage,
  RecAssignLens,
  RecPriority,
  RecScope,
  SyncDirection,
  RecFootnoteType,
  InstructionType,
  RecTimeHorizon,
  InstructionValue,
  ResourceType,
  GroupingDimension,
  PlanAccessSetting,
  ViewMode,
  OriginAction,
  TimelineViewType,
  LoopCreationPath,
  VisualizationArtifactFormat,
  identifiedUserTempoLoop,
  pageViewed,
  pageViewedLoopIntelligence,
  planCreated,
  planCreatedTempoSpm,
  teamImportedLoop,
  userInviteSent,
  organizationCreated,
  itemSearched,
  askAiInteracted,
  planScopeFiltered,
  planAccessUpdated,
  portfolioItemsEdited,
  scenarioParametersAdjusted,
  portfolioLoopCreated,
  userInviteAccepted,
  integrationCreated,
  instanceCreated,
  portfolioViewed,
  scenarioCreated,
  scenarioActivated,
  visualizationPublished,
  scenarioItemsEdited,
  scenarioParametersApplied,
  recommendationCategoryFiltered,
  insightViewModeToggled,
  insightGroupingChanged,
  workItemLinkClicked,
  itemPanelTabSwitched,
  itemPanelExpanded,
  itemFieldUpdated,
  organizationIdentified,
  visualizationUpdated,
  itemSyncInitiated,
  portfolioItemCreated,
  dashboardCreated,
  workTitleSet,
  recommendationLoopFiltered,
  recommendationRowExpanded,
  recommendationAffectedItemsExpanded,
  recommendationFeedbackClicked,
  recommendationFeedbackFormDismissed,
  recommendationFeedbackFormSubmitted,
  recommendationActionsExpanded,
  recommendationFootnoteExpanded,
  readingViewToggled,
  recommendationActionClicked,
  recommendationActionReverted,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["identifiedUserTempoLoop","pageViewed","pageViewedLoopIntelligence","planCreated","planCreatedTempoSpm","teamImportedLoop","userInviteSent","organizationCreated","itemSearched","askAiInteracted","planScopeFiltered","planAccessUpdated","portfolioItemsEdited","scenarioParametersAdjusted","portfolioLoopCreated","userInviteAccepted","integrationCreated","instanceCreated","portfolioViewed","scenarioCreated","scenarioActivated","visualizationPublished","scenarioItemsEdited","scenarioParametersApplied","recommendationCategoryFiltered","insightViewModeToggled","insightGroupingChanged","workItemLinkClicked","itemPanelTabSwitched","itemPanelExpanded","itemFieldUpdated","organizationIdentified","visualizationUpdated","itemSyncInitiated","portfolioItemCreated","dashboardCreated","workTitleSet","recommendationLoopFiltered","recommendationRowExpanded","recommendationAffectedItemsExpanded","recommendationFeedbackClicked","recommendationFeedbackFormDismissed","recommendationFeedbackFormSubmitted","recommendationActionsExpanded","recommendationFootnoteExpanded","readingViewToggled","recommendationActionClicked","recommendationActionReverted"]
